import _toConsumableArray from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/defineProperty";
import _slicedToArray2 from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
 * Tools for creating TypeGuards.
 */
var isNull = function isNull(u) {
  return u === null;
};

var isString = function isString(u) {
  return typeof u === 'string';
};

var isNumber = function isNumber(u) {
  return typeof u === 'number';
};

var isBoolean = function isBoolean(u) {
  return typeof u === 'boolean';
};

var isOptional = function isOptional(guard) {
  return function (u) {
    return u === undefined || guard(u);
  };
};

var isArrayOf = function isArrayOf(guard) {
  return function (u) {
    return Array.isArray(u) && u.every(guard);
  };
}; /// TypeGuard for discriminated unions of strings


var isOneOf = function isOneOf(list) {
  return function (u) {
    return !!list.find(function (i) {
      return i === u;
    });
  };
}; /// TypeGuard for fixed values


var isFixed = function isFixed(value) {
  return function (u) {
    return u === value;
  };
}; // type guard operators
/// TypeGuard for discriminated unions of objects


var isEither = function isEither(list) {
  return function (u) {
    return !!list.find(function (g) {
      return g(u);
    });
  };
};

var isNullable = function isNullable(guard) {
  return function (u) {
    if (u === null) {
      return true;
    }

    var res = guard(u);
    return typeof res === 'boolean' && res;
  };
};
/** *
 * TypeGuard for an object. Needs to have one Guard for every attribute
 *  */


var typeGuard = function typeGuard(guards) {
  return function (u) {
    return Object.entries(guards).every(function (_ref) {
      var _ref2 = _slicedToArray2(_ref, 2),
          key = _ref2[0],
          guard = _ref2[1];

      if (!u) {
        return false;
      }

      var value = u[key];

      if (!guard(value)) {
        return false;
      }

      return true;
    });
  };
};
/** *
 * TypeAssertion for an object. Needs to have one Guard or TypeAssertion for every attribute.
 * Will throw an error if the property is of the wrong type.
 *  */
// TODO: refactor the typeGuard function to work as a typeAssertion when called by a typeAssertion


function typeAssertion(guards) {
  return function assertGuard(u) {
    // for function Guards like `isEither`
    if (typeof guards === 'function') {
      var res = guards(u);

      if (typeof res === 'boolean' && !res) {
        throw new Error('failed-typeguard');
      }

      return;
    } // default with a Guard object


    Object.entries(guards).forEach(function (_ref3) {
      var _ref4 = _slicedToArray2(_ref3, 2),
          key = _ref4[0],
          guard = _ref4[1];

      if (!u) {
        throw new Error("Can't read property '".concat(key, "' of '").concat(u, "'"));
      }

      var value = u[key];

      try {
        var _res = guard(value);

        if (typeof _res === 'boolean' && !_res) {
          throw new Error('failed-typeguard');
        }
      } catch (e) {
        // TODO: write or install a nested error object
        throw new Error("Value '".concat(value, "' has the wrong type for property '").concat(key, "':", '\n').concat(e && e.message));
      }
    });
  };
}

var questionTypeFamilies = ['PRESENTATION', 'MULTIPLE_CHOICE', 'OPEN_ENDED', 'RATING_SCALE', 'MATRIX', 'RANKING', 'SLIDER', 'DATETIME', 'CONTACT_INFO', 'CLICK_MAP', 'FILE_UPLOAD'];
var questionTypeRequiredPredicateTypes = ['ALL', 'AT_LEAST', 'AT_MOST', 'EXACTLY', 'RANGE', 'REQUIRED_ANSWERS_LIST'];
var questionTypeVariants = ['TEXT', 'IMAGE', 'SINGLE_LINE', 'ESSAY', 'MANY_FIELDS', 'SINGLE_ANSWER_RADIO', 'SINGLE_ANSWER_SYMBOL', 'SINGLE_ANSWER_MENU', 'MANY_ANSWERS_CHECKBOX', 'MENU', 'SINGLE_SLIDER', 'DATE', 'TIME', 'DATETIME', 'MANY_FIELDS', 'SINGLE_CLICK', null];
var questionTypeLayoutPlacements = ['NEW_ROW', 'RIGHT_ALIGNED'];
var questionTypeHeaderColumnWidths = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
var questionTypeValidationTypes = ['SUM', 'TEXT_LENGTH', 'EMAIL', 'INTEGER', 'DECIMAL', 'DATE_US', 'DATE_INTL', 'FILE_FORMAT'];
var questionTypeFileFormats = ['PDF', 'DOC', 'DOCX', 'PNG', 'JPG', 'JPEG', 'GIF'];
var questionTypeTextLineOptions = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
var questionTypeTextWidthOptions = [5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
var questionTypeIds = ['single_textbox', 'comment_box'];
var questionTypeSortingKinds = ['FLIP', 'RANDOM', 'TEXT_ASC', 'TEXT_DESC'];
var questionTypeSkipLogicTypes = ['QUESTION_CONDITIONAL_COL', 'QUESTION_CONDITIONAL_ROW'];
var questionTypeSkipLogicDestinationTypes = ['DISQUALIFY_RESPONDENT', 'END_SURVEY', 'SKIP_TO_PAGE'];
var questionTypeMultipleChoiceLayouts = ['VERTICAL', 'THREE_COLUMNS', 'TWO_COLUMNS', 'HORIZONTAL'];
var SENTIMENTS = ['positive', 'negative', 'neutral', 'unknown'];
/** Possible icons for Star-Rating */

var ratingScaleSymbols = ['THUMB', 'STAR', 'HEART', 'SMILEY'];
/** Possible values for relative width (in percentage) */

var relativeWidthOptions = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
/** Possible values for fixed width (in pixel) */

var fixedWidthOptions = [100, 200, 300, 400, 500, 600, 700, 800]; /// Base Types
/// Question Guard Helpers

var isQuestionError = isEither([typeGuard({
  type: isFixed('local-error'),
  id: isString,
  field: isString,
  message: isString
}), typeGuard({
  type: isFixed('upstream-error'),
  context: isString,
  id: isString,
  message: isString
})]);
/** baseQuestionGuards
 * --------------------------
 * Question guards for the common fields for a Question Type.
 * should receive the type parameters for the actual ID, FAMILY and SUBTYPE of the
 * Question Type to avoid Typescript errors. Question types should use this function
 * to help build their own typeGuards
 */

var singleStringValueBaseAnswerTypeGuards = {
  touched: isBoolean,
  value: isString
};

var multipleChoiceAnswerTypeGuards = _objectSpread(_objectSpread({}, singleStringValueBaseAnswerTypeGuards), {}, {
  id: isString,
  selected: isBoolean,
  label: isString,
  visible: isBoolean
});

var otherAnswerChoiceTypeGuards = _objectSpread(_objectSpread({}, singleStringValueBaseAnswerTypeGuards), {}, {
  id: isString,
  type: isFixed('ANSWER'),
  label: isString,
  visible: isBoolean,
  requiredErrorText: isString,
  linesCount: isOneOf(questionTypeTextLineOptions),
  charsCount: isOneOf(questionTypeTextWidthOptions)
});

var otherAnswerCommentTypeGuards = _objectSpread(_objectSpread({}, singleStringValueBaseAnswerTypeGuards), {}, {
  id: isString,
  type: isFixed('COMMENT'),
  label: isString,
  visible: isBoolean,
  selected: isBoolean,
  linesCount: isOneOf(questionTypeTextLineOptions),
  charsCount: isOneOf(questionTypeTextWidthOptions)
});

var isMultipleChoiceAnswerType = typeGuard(multipleChoiceAnswerTypeGuards);
var isOtherAnswerChoiceType = typeGuard(otherAnswerChoiceTypeGuards);
var isOtherAnswerCommentType = typeGuard(otherAnswerCommentTypeGuards);

var baseQuestionGuards = function baseQuestionGuards(typeId, family, variant) {
  return {
    typeId: isFixed(typeId),
    variant: isFixed(variant),
    family: isFixed(family),
    id: isString,
    errors: isOptional(isArrayOf(isQuestionError))
  };
};
/** isQuestionType
 * --------------------------
 * a very basic typeguard for the common fields for a Question Type.
 * should receive parameters for the actual ID, FAMILY and SUBTYPE of the
 * Question Type to avoid Typescript errors. Question types can use this function
 * to help build their own typeGuards
 */


var isQuestionType = function isQuestionType(typeId, family, variant) {
  return typeGuard(baseQuestionGuards(typeId, family, variant));
};

var isTextLengthValidation = typeGuard({
  errorMessage: isString,
  type: isFixed('TEXT_LENGTH'),
  minLength: isNumber,
  maxLength: isNumber
});
var isIntegerValidation = typeGuard({
  errorMessage: isString,
  type: isFixed('INTEGER'),
  minValue: isNumber,
  maxValue: isNumber
});
var isDecimalValidation = typeGuard({
  errorMessage: isString,
  type: isFixed('DECIMAL'),
  minValue: isNumber,
  maxValue: isNumber
});
var isDateValidation = typeGuard({
  errorMessage: isString,
  type: isOneOf(['DATE_US', 'DATE_INTL']),
  minDate: isString,
  maxDate: isString
});
var isEmailValidation = typeGuard({
  errorMessage: isString,
  type: isFixed('EMAIL')
});
var isSumValidation = typeGuard({
  errorMessage: isString,
  type: isFixed('SUM'),
  sum: isNumber
});
var isFieldValidation = isEither([isTextLengthValidation, isIntegerValidation, isDecimalValidation, isDateValidation, isEmailValidation]);
var headingGuards = typeGuard({
  "default": typeGuard({
    text: isString
  }),
  assignments: isOptional(isArrayOf(typeGuard({
    id: isString,
    heading: typeGuard({
      text: isString
    }),
    variable: typeGuard({
      id: isString,
      name: isNullable(isString),
      percent: isNumber,
      position: isNumber
    })
  })))
});
var positionGuard = {
  position: typeGuard({
    inPage: isNumber,
    inSurvey: isNumber,
    label: isString
  })
};
var baseGuards$a = {
  id: isString
};
/** Guard for basic fields shared by all QuestionTypes' in the Response-Survey capabilities */

var surveyQuestionGuards = _objectSpread(_objectSpread(_objectSpread({}, baseGuards$a), positionGuard), {}, {
  // TODO: remove this
  family: isOneOf(questionTypeFamilies),
  variant: isOneOf(questionTypeVariants),
  heading: headingGuards,
  hasPiping: isBoolean,
  createdAt: isString,
  modifiedAt: isString
});

var externalQuizResultsGuards = {
  id: isString,
  feedback: typeGuard({
    correct: isString,
    partial: isString,
    incorrect: isString
  }),
  answers: isArrayOf(typeGuard({
    answer: isEither([typeGuard({
      id: isString,
      label: isString,
      visible: isBoolean
    }), typeGuard({
      id: isString
    })]),
    points: isNumber,
    responded: isBoolean
  })),

  /** custom field - not in this spot in the GraphQL Schema (data from `OtherResponse`)) */
  answerOther: isOptional(typeGuard({
    textAnswer: isOptional(isString)
  })),
  totalPoints: isNumber
};
var isSurveyQuestion = typeGuard(surveyQuestionGuards);
var isQuestionLayoutPlacement = isOneOf(questionTypeLayoutPlacements);
var isQuestionLayoutSpacing = typeGuard({
  left: isNumber,
  right: isNumber,
  top: isNumber,
  bottom: isNumber
});
var isQuestionLayoutWidth = isEither([typeGuard({
  format: isFixed('PERCENT'),
  width: isOneOf(relativeWidthOptions)
}), typeGuard({
  format: isFixed('FIXED'),
  width: isOneOf(fixedWidthOptions)
})]);
var isQuestionLayoutHeaderColumnWidth = isOneOf(questionTypeHeaderColumnWidths);
/** Internal non-nullable version */

var isAnswer = typeGuard({
  id: isString,
  label: isString,
  visible: isBoolean
});
/** Internal non-nullable version */

var isAnswerOtherCommentNonNullable = typeGuard({
  id: isString,
  label: isString,
  visible: isBoolean,
  type: isFixed('COMMENT'),
  layout: typeGuard({
    linesCount: isOneOf(questionTypeTextLineOptions),
    charsCount: isOneOf(questionTypeTextWidthOptions)
  })
});
/** Internal non-nullable version */

var isAnswerOtherChoiceNonNullable = typeGuard({
  id: isString,
  label: isString,
  visible: isBoolean,
  type: isFixed('ANSWER'),
  requiredErrorText: isString,
  layout: typeGuard({
    linesCount: isOneOf(questionTypeTextLineOptions),
    charsCount: isOneOf(questionTypeTextWidthOptions)
  })
});
var isAnswerOther = isNullable(isEither([isAnswerOtherChoiceNonNullable, isAnswerOtherCommentNonNullable]));
var isAnswerOtherComment = isNullable(isAnswerOtherCommentNonNullable);
var isAnswerNoneOfTheAbove = isNullable(typeGuard({
  id: isString,
  label: isString,
  visible: isBoolean
}));
var isFieldSet = typeGuard({
  id: isString,
  visible: isBoolean
});
var isAllAnswerRequired = typeGuard({
  errorMessage: isString,
  type: isFixed('ALL')
});
/** Internal non-nullable version */

var isWeightedAnswer = typeGuard({
  id: isString,
  label: isString,
  weight: isNumber,
  visible: isBoolean
});
var isWeightedAnswers = isArrayOf(isWeightedAnswer);
var isQuestionSorting = isNullable(typeGuard({
  ignoreLast: isBoolean,
  type: isOneOf(questionTypeSortingKinds)
}));
var isQuestionSkipLogicRules = isArrayOf(typeGuard({
  id: isString,
  skipType: isOneOf(questionTypeSkipLogicTypes),
  sourceAnswer: isEither([isAnswer, isAnswerOtherChoiceNonNullable, isWeightedAnswer]),
  destination: isEither([typeGuard({
    type: isOneOf(['DISQUALIFY_RESPONDENT', 'END_SURVEY'])
  }), // ensure `SKIP_TO_PAGE` also has a question prop
  typeGuard({
    type: isFixed('SKIP_TO_PAGE'),
    question: isSurveyQuestion
  })])
}));
var isExternalQuestionWithTypeId = typeGuard({
  typeId: isString
});
var isAnswerRangeRequired = typeGuard({
  type: isFixed('RANGE'),
  min: isNumber,
  max: isNumber,
  errorMessage: isString
});
var isAnswerCountPredicateRequired = typeGuard({
  errorMessage: isString,
  type: isOneOf(['AT_LEAST', 'AT_MOST', 'EXACTLY']),
  amount: isNumber
});

function assertExternalQuestionWithIds(u) {
  return typeAssertion({
    typeId: isString,
    id: isString
  })(u);
}
/** Only used for Respondent Survey */


var basicExternalAllMultipleChoiceGuards = {
  fieldSet: isFieldSet,
  sorting: isQuestionSorting,
  required: isNullable(isAllAnswerRequired)
};
var basicExternalMultipleChoiceAnswersGuard = {
  answers: isArrayOf(typeGuard({
    id: isString,
    label: isString,
    visible: isBoolean
  }))
};
var basicExternalMultipleChoiceValidationGuard = {
  validation: isNullable(isEither([isTextLengthValidation, isIntegerValidation, isDecimalValidation, isDateValidation, isEmailValidation]))
};
var basicExternalMultipleChoiceLayoutGuard = {
  layout: typeGuard({
    answerLayout: isOneOf(questionTypeMultipleChoiceLayouts),
    placement: isQuestionLayoutPlacement,
    width: isQuestionLayoutWidth,
    spacing: isQuestionLayoutSpacing
  })
};
var basicExternalMultipleChoiceAnswerOtherGuard = {
  answerOther: isAnswerOther
};
var basicExternalMultipleChoiceAnswerNoneOfTheAboveGuard = {
  answerNoneOfTheAbove: isNullable(typeGuard({
    id: isString,
    label: isString,
    visible: isBoolean
  }))
};
/** Shared ExternalQuestion Guards for Respondent-Survey capability */

var externalRespondentSurveyGuards = _objectSpread(_objectSpread({}, positionGuard), {}, {
  heading: headingGuards,
  hasPiping: isBoolean,

  /** Not part of GraphQL Schema */
  errors: isArrayOf(isQuestionError),

  /** Not part of GraphQL Schema and only used for _One Question At A Time_ mode */
  active: isOptional(isBoolean)
});

var isAggregateResponseHeaderItem$1 = typeGuard({
  id: isString,
  label: isString,
  weight: isNullable(isNumber)
});
var isAggregateResponseHeader$1 = typeGuard({
  id: isString,
  items: isArrayOf(isAggregateResponseHeaderItem$1)
});
/** Shared ExternalQuestion Guards for Respondent-Quiz-Results capability */

var externalRespondentQuizResultsGuards = _objectSpread(_objectSpread({}, positionGuard), {}, {
  heading: headingGuards,
  quizResults: isNullable(typeGuard(externalQuizResultsGuards))
});
/** Shared ExternalQuestion Guards for AggregateResponse-Dashboard capability */


var externalAggregateResponseDashboardGuards = {
  dashboardType: isOptional(isEither([isFixed('slide'), isFixed('list'), isFixed('sentiment-chart')])),
  filterCount: isOptional(isNumber),
  selectedCount: isOptional(isNumber),
  skippedCount: isOptional(isNumber),
  responseData: isOptional(isNullable(isArrayOf(typeGuard({
    content: isString,
    id: isString,
    sentiment: isEither([isFixed('positive'), isFixed('negative'), isFixed('neutral'), isFixed('unknown')])
  })))),
  aggregateResponse: isOptional(typeGuard({
    columnHeader: isNullable(isAggregateResponseHeader$1),
    rowHeader: isAggregateResponseHeader$1,
    groupHeader: isNullable(isAggregateResponseHeader$1),
    data: isArrayOf(typeGuard({
      columnItem: isNullable(isAggregateResponseHeaderItem$1),
      rowItem: isNullable(isAggregateResponseHeaderItem$1),
      groupItem: isNullable(isAggregateResponseHeaderItem$1),
      percentage: isNumber,
      total: isNumber
    })),
    id: isString,
    stats: isArrayOf(typeGuard({
      across: isNullable(isEither([isFixed('COLUMNS'), isFixed('GROUPS'), isFixed('ROWS')])),
      row: isNullable(isAggregateResponseHeaderItem$1),
      column: isNullable(isAggregateResponseHeaderItem$1),
      group: isNullable(isAggregateResponseHeaderItem$1)
    })),
    type: isEither([isFixed('ONE_D'), isFixed('TWO_D'), isFixed('THREE_D')])
  })),
  heading: headingGuards
};
/** List of all smQuestion supported capabilities (others might get defined via custom providers/views) */

var CAPABILITIES = ['respondent-survey', 'respondent-quiz-results', 'aggregate-response-dashboard'];

function assertExternalQuestionByCapability(externalQuestion, guards) {
  return typeAssertion(guards)(externalQuestion);
}

function respondentSurveyMapping(externalQuestion) {
  assertExternalQuestionByCapability(externalQuestion, externalRespondentSurveyGuards);
  var heading = externalQuestion.heading,
      position = externalQuestion.position,
      errors = externalQuestion.errors,
      active = externalQuestion.active;
  return {
    errors: errors,
    active: active,
    questionNumber: position.label,
    title: heading["default"].text,
    disabled: false,
    answer: {
      touched: false,
      value: ''
    }
  };
}

function respondentQuizResultsMapping(externalQuestion) {
  assertExternalQuestionByCapability(externalQuestion, externalRespondentQuizResultsGuards);
  return {
    quizResults: externalQuestion.quizResults || undefined,
    questionNumber: externalQuestion.position.label,
    title: externalQuestion.heading["default"].text
  };
}

function aggregateResponseDashboardMapping(externalQuestion) {
  assertExternalQuestionByCapability(externalQuestion, externalAggregateResponseDashboardGuards);
  var dashboardType = externalQuestion.dashboardType,
      filterCount = externalQuestion.filterCount,
      selectedCount = externalQuestion.selectedCount,
      skippedCount = externalQuestion.skippedCount,
      responseData = externalQuestion.responseData,
      aggregateResponse = externalQuestion.aggregateResponse,
      title = externalQuestion.heading["default"].text;
  return {
    dashboardType: dashboardType,
    filterCount: filterCount,
    selectedCount: selectedCount,
    skippedCount: skippedCount,
    responseData: responseData,
    aggregateResponse: aggregateResponse,
    title: title
  };
}
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */


function assertBasicFields(externalQuestion) {
  return typeAssertion(baseGuards$a)(externalQuestion);
}

function basicFieldsMapping(externalQuestion) {
  assertBasicFields(externalQuestion);
  var id = externalQuestion.id;
  return {
    id: id
  };
}
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */


var basicExternalImageChoiceGuards = {
  family: isFixed('MULTIPLE_CHOICE'),
  variant: isEither([isFixed('MANY_ANSWERS_IMAGE'), isFixed('SINGLE_ANSWER_IMAGE')])
};

function assertExternalImageChoice(externalQuestion) {
  return typeAssertion(basicExternalImageChoiceGuards)(externalQuestion);
}
/** Map fields shared by all capabilities */


var mapExternalToInternalImageChoice = function mapExternalToInternalImageChoice(externalQuestion) {
  assertExternalImageChoice(externalQuestion);
  var variant = externalQuestion.variant,
      family = externalQuestion.family;
  var typeId = variant === 'SINGLE_ANSWER_IMAGE' ? 'image_choice_single_answer' : 'image_choice_many_answers';
  return {
    typeId: typeId,
    variant: variant,
    family: family,
    disabled: false
  };
};

var answersImageGuards = {
  answersImage: isArrayOf(typeGuard({
    id: isString,
    image: typeGuard({
      altText: isString,
      url: isString
    }),
    label: isString,
    visible: isBoolean
  }))
};
/** Assertion for Respondent-Survey */

function assertRespondentSurvey$a(u) {
  return typeAssertion(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basicExternalAllMultipleChoiceGuards), basicExternalMultipleChoiceAnswerNoneOfTheAboveGuard), answersImageGuards), {}, {
    skipLogicRules: isQuestionSkipLogicRules
  }))(u);
}

var mapRespondentSurveyExternalImageChoice = function mapRespondentSurveyExternalImageChoice(externalQuestion) {
  assertRespondentSurvey$a(externalQuestion);
  var answerNoneOfTheAbove = externalQuestion.answerNoneOfTheAbove,
      answersImage = externalQuestion.answersImage,
      fieldSet = externalQuestion.fieldSet,
      required = externalQuestion.required,
      skipLogicRules = externalQuestion.skipLogicRules,
      sorting = externalQuestion.sorting;
  return {
    answerNoneOfTheAbove: answerNoneOfTheAbove,
    answersImage: answersImage,
    fieldSet: fieldSet,
    required: required,
    skipLogicRules: skipLogicRules,
    sorting: sorting
  };
};
/** Assertion for Respondent-Quiz-Results */


function assertRespondentQuizResults$2(u) {
  return typeAssertion(typeGuard(_objectSpread(_objectSpread({}, basicExternalMultipleChoiceAnswerNoneOfTheAboveGuard), answersImageGuards)))(u);
}
/** Map Respondent-Quiz-Results specific properties */


var mapRespondentQuizResultsExternalImageChoice = function mapRespondentQuizResultsExternalImageChoice(externalQuestion) {
  assertRespondentQuizResults$2(externalQuestion);
  var answerNoneOfTheAbove = externalQuestion.answerNoneOfTheAbove,
      answersImage = externalQuestion.answersImage;
  return {
    answerNoneOfTheAbove: answerNoneOfTheAbove,
    answersImage: answersImage
  };
}; // Respondent-Survey


var imageChoiceRespondentSurveyMapping = function imageChoiceRespondentSurveyMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basicFieldsMapping(externalQuestion)), respondentSurveyMapping(externalQuestion)), mapExternalToInternalImageChoice(externalQuestion)), mapRespondentSurveyExternalImageChoice(externalQuestion));
}; // Respondent-Quiz-Results


var imageChoiceRespondentQuizResultsMapping = function imageChoiceRespondentQuizResultsMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basicFieldsMapping(externalQuestion)), respondentQuizResultsMapping(externalQuestion)), mapExternalToInternalImageChoice(externalQuestion)), mapRespondentQuizResultsExternalImageChoice(externalQuestion));
}; // Aggregate-Response-Dashboard


var imageChoiceAggregateResponseDashboardMapping = function imageChoiceAggregateResponseDashboardMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread({}, basicFieldsMapping(externalQuestion)), aggregateResponseDashboardMapping(externalQuestion)), mapExternalToInternalImageChoice(externalQuestion));
};
/** Guard to check properties shared by all capabilities */


var basicExternalCheckBoxGuards = {
  family: isFixed('MULTIPLE_CHOICE'),
  variant: isFixed('MANY_ANSWERS_CHECKBOX')
};
/** Assertion to check properties shared by all capabilities */

function assertExternalCheckBox(externalQuestion) {
  return typeAssertion(basicExternalCheckBoxGuards)(externalQuestion);
}
/** Map fields shared by all capabilities */


var mapExternalToInternalCheckBox = function mapExternalToInternalCheckBox(externalQuestion) {
  assertExternalCheckBox(externalQuestion);
  var variant = externalQuestion.variant,
      family = externalQuestion.family;
  return {
    variant: variant,
    family: family,
    disabled: false
  };
};
/** Assertion for Respondent-Survey specific properties */


function assertRespondentSurvey$9(u) {
  return typeAssertion(typeGuard(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basicExternalMultipleChoiceAnswersGuard), basicExternalMultipleChoiceAnswerOtherGuard), basicExternalMultipleChoiceAnswerNoneOfTheAboveGuard), basicExternalMultipleChoiceLayoutGuard), basicExternalMultipleChoiceValidationGuard), isNullable(isAllAnswerRequired))))(u);
}
/** Map Respondent-Survey specific properties */


var mapRespondentSurveyExternalCheckBox = function mapRespondentSurveyExternalCheckBox(externalQuestion) {
  assertRespondentSurvey$9(externalQuestion);
  var layout = externalQuestion.layout,
      validation = externalQuestion.validation,
      required = externalQuestion.required,
      answers = externalQuestion.answers,
      answerOther = externalQuestion.answerOther,
      answerNoneOfTheAbove = externalQuestion.answerNoneOfTheAbove;
  return {
    layout: layout,
    validation: validation,
    required: required,
    answers: answers,
    answerOther: answerOther ? _objectSpread(_objectSpread({
      id: answerOther.id,
      touched: false,
      value: '',
      label: answerOther.label,
      selected: false,
      visible: answerOther.visible,
      type: answerOther.type
    }, answerOther.type === 'ANSWER' ? {
      requiredErrorText: answerOther.requiredErrorText
    } : {}), {}, {
      linesCount: answerOther.layout.linesCount,
      charsCount: answerOther.layout.charsCount
    }) : null,
    answerNoneOfTheAbove: answerNoneOfTheAbove
  };
};
/** Assertion for Respondent-Quiz-Results */


function assertRespondentQuizResults$1(u) {
  return typeAssertion(typeGuard(_objectSpread(_objectSpread(_objectSpread({}, basicExternalMultipleChoiceLayoutGuard), basicExternalMultipleChoiceAnswerOtherGuard), basicExternalMultipleChoiceAnswerNoneOfTheAboveGuard)))(u);
}

var mapRespondentQuizResultsExternalCheckBox = function mapRespondentQuizResultsExternalCheckBox(externalQuestion) {
  assertRespondentQuizResults$1(externalQuestion);
  var layout = externalQuestion.layout,
      answerOther = externalQuestion.answerOther,
      answerNoneOfTheAbove = externalQuestion.answerNoneOfTheAbove;
  return {
    layout: layout,
    answerOther: answerOther ? _objectSpread(_objectSpread({
      id: answerOther.id,
      label: answerOther.label,
      visible: answerOther.visible,
      type: answerOther.type
    }, answerOther.type === 'ANSWER' ? {
      requiredErrorText: answerOther.requiredErrorText
    } : {}), {}, {
      linesCount: answerOther.layout.linesCount,
      charsCount: answerOther.layout.charsCount
    }) : null,
    answerNoneOfTheAbove: answerNoneOfTheAbove
  };
}; // Respondent-Survey


var checkBoxRespondentSurveyMapping = function checkBoxRespondentSurveyMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'check_box'
  }, basicFieldsMapping(externalQuestion)), respondentSurveyMapping(externalQuestion)), mapExternalToInternalCheckBox(externalQuestion)), mapRespondentSurveyExternalCheckBox(externalQuestion));
}; // Respondent-Quiz-Results


var checkBoxRespondentQuizResultsMapping = function checkBoxRespondentQuizResultsMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'check_box'
  }, basicFieldsMapping(externalQuestion)), respondentQuizResultsMapping(externalQuestion)), mapExternalToInternalCheckBox(externalQuestion)), mapRespondentQuizResultsExternalCheckBox(externalQuestion));
}; // Aggregate-Response-Dashboard


var checkBoxAggregateResponseDashboardMapping = function checkBoxAggregateResponseDashboardMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread({
    typeId: 'check_box'
  }, basicFieldsMapping(externalQuestion)), aggregateResponseDashboardMapping(externalQuestion)), mapExternalToInternalCheckBox(externalQuestion));
};
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */


var basicExternalDropdownGuards = {
  variant: isFixed('SINGLE_ANSWER_MENU'),
  family: isFixed('MULTIPLE_CHOICE')
};

function assertExternalDropdown(externalQuestion) {
  return typeAssertion(basicExternalDropdownGuards)(externalQuestion);
}
/** Map fields shared by all capabilities */


var mapExternalToInternalDropdown = function mapExternalToInternalDropdown(externalQuestion) {
  assertExternalDropdown(externalQuestion);
  var variant = externalQuestion.variant,
      family = externalQuestion.family;
  return {
    variant: variant,
    family: family,
    disabled: false
  };
};
/** Assertion for Respondent-Survey specific properties */


function assertRespondentSurvey$8(u) {
  return typeAssertion(typeGuard(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basicExternalAllMultipleChoiceGuards), basicExternalMultipleChoiceLayoutGuard), basicExternalMultipleChoiceValidationGuard), basicExternalMultipleChoiceAnswersGuard), basicExternalMultipleChoiceAnswerOtherGuard)))(u);
}
/** Map Respondent-Survey specific properties */


var mapRespondentSurveyExternalDropdown = function mapRespondentSurveyExternalDropdown(externalQuestion) {
  assertRespondentSurvey$8(externalQuestion); // Placeholder - we don't have this visualization yet

  var layout = externalQuestion.layout,
      validation = externalQuestion.validation,
      answerOther = externalQuestion.answerOther,
      required = externalQuestion.required,
      answers = externalQuestion.answers;
  return {
    required: required,
    layout: layout,
    validation: validation,
    answers: answers,
    answerOther: answerOther ? _objectSpread(_objectSpread({
      id: answerOther.id,
      label: answerOther.label,
      touched: false,
      value: '',
      selected: false,
      visible: answerOther.visible,
      type: answerOther.type
    }, answerOther.type === 'ANSWER' ? {
      requiredErrorText: answerOther.requiredErrorText
    } : {}), {}, {
      linesCount: answerOther.layout.linesCount,
      charsCount: answerOther.layout.charsCount
    }) : null
  };
};
/** Assertion for Respondent-Survey specific properties */


function assertQuizResults(u) {
  return typeAssertion(typeGuard(_objectSpread(_objectSpread({}, basicExternalMultipleChoiceAnswerOtherGuard), basicExternalMultipleChoiceLayoutGuard)))(u);
}

var mapRespondentQuizResultsExternalDropdown = function mapRespondentQuizResultsExternalDropdown(externalQuestion) {
  assertQuizResults(externalQuestion);
  var layout = externalQuestion.layout,
      answerOther = externalQuestion.answerOther;
  return {
    layout: layout,
    answerOther: answerOther ? _objectSpread(_objectSpread({
      id: answerOther.id,
      label: answerOther.label,
      visible: answerOther.visible,
      type: answerOther.type
    }, answerOther.type === 'ANSWER' ? {
      requiredErrorText: answerOther.requiredErrorText
    } : {}), {}, {
      linesCount: answerOther.layout.linesCount,
      charsCount: answerOther.layout.charsCount
    }) : null
  };
}; // Respondent-Survey


var dropdownRespondentSurveyMapping = function dropdownRespondentSurveyMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'dropdown'
  }, basicFieldsMapping(externalQuestion)), respondentSurveyMapping(externalQuestion)), mapExternalToInternalDropdown(externalQuestion)), mapRespondentSurveyExternalDropdown(externalQuestion));
}; // Respondent-Quiz-Results


var dropdownRespondentQuizResultsMapping = function dropdownRespondentQuizResultsMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'dropdown'
  }, basicFieldsMapping(externalQuestion)), respondentQuizResultsMapping(externalQuestion)), mapExternalToInternalDropdown(externalQuestion)), mapRespondentQuizResultsExternalDropdown(externalQuestion));
}; // Aggregate-Response-Dashboard


var dropdownAggregateResponseDashboardMapping = function dropdownAggregateResponseDashboardMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread({
    typeId: 'dropdown'
  }, basicFieldsMapping(externalQuestion)), aggregateResponseDashboardMapping(externalQuestion)), mapExternalToInternalDropdown(externalQuestion));
};

var basicExternalFieldSetGuards = {
  fieldSet: isFieldSet
};
var basicExternalRequiredGuards = {
  required: isNullable(isAllAnswerRequired)
};
var basicExternalOpenEndedLayoutGuards = {
  layout: typeGuard({
    placement: isQuestionLayoutPlacement,
    spacing: isQuestionLayoutSpacing,
    linesCount: isNumber,
    charsCount: isNumber
  })
};
var basicExternalOpenEndedValidationGuards = {
  validation: isNullable(isEither([isTextLengthValidation, isIntegerValidation, isDecimalValidation, isDateValidation, isEmailValidation]))
};
var basicExternalCommentBoxGuards = {
  family: isFixed('OPEN_ENDED'),
  variant: isFixed('ESSAY')
};

function assertExternalCommentBox(externalQuestion) {
  return typeAssertion(basicExternalCommentBoxGuards)(externalQuestion);
}

var mapExternalToInternalCommentBox = function mapExternalToInternalCommentBox(externalQuestion) {
  assertExternalCommentBox(externalQuestion);
  var variant = externalQuestion.variant,
      family = externalQuestion.family;
  return {
    variant: variant,
    family: family,
    disabled: false
  };
};
/** Assertion for Respondent-Survey */


function assertRespondentSurvey$7(u) {
  return typeAssertion(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basicExternalFieldSetGuards), basicExternalRequiredGuards), basicExternalOpenEndedLayoutGuards), basicExternalOpenEndedValidationGuards))(u);
}

var mapRespondentSurveyExternalCommentBox = function mapRespondentSurveyExternalCommentBox(externalQuestion) {
  assertRespondentSurvey$7(externalQuestion);
  var layout = externalQuestion.layout,
      validation = externalQuestion.validation,
      required = externalQuestion.required,
      fieldSet = externalQuestion.fieldSet;
  return {
    layout: layout,
    validation: validation,
    required: required,
    fieldSet: fieldSet
  };
}; // Respondent-Survey


var commentBoxRespondentSurveyMapping = function commentBoxRespondentSurveyMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'comment_box'
  }, basicFieldsMapping(externalQuestion)), respondentSurveyMapping(externalQuestion)), mapExternalToInternalCommentBox(externalQuestion)), mapRespondentSurveyExternalCommentBox(externalQuestion));
}; // Aggregate-Response-Dashboard


var commentBoxAggregateResponseDashboardMapping = function commentBoxAggregateResponseDashboardMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread({
    typeId: 'comment_box'
  }, basicFieldsMapping(externalQuestion)), aggregateResponseDashboardMapping(externalQuestion)), mapExternalToInternalCommentBox(externalQuestion));
};

var basicExternalSingleTextboxGuards = {
  family: isFixed('OPEN_ENDED'),
  variant: isFixed('SINGLE_LINE')
};

function assertExternalSingleTextbox(externalQuestion) {
  return typeAssertion(basicExternalSingleTextboxGuards)(externalQuestion);
}
/** Map fields shared by all capabilities */


var mapExternalToInternalSingleTextbox = function mapExternalToInternalSingleTextbox(externalQuestion) {
  assertExternalSingleTextbox(externalQuestion);
  var variant = externalQuestion.variant,
      family = externalQuestion.family;
  return {
    variant: variant,
    family: family,
    disabled: false
  };
};
/** Assertion for Respondent-Survey */


function assertRespondentSurvey$6(u) {
  return typeAssertion(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basicExternalFieldSetGuards), basicExternalRequiredGuards), basicExternalOpenEndedLayoutGuards), basicExternalOpenEndedValidationGuards))(u);
}

var mapRespondentSurveyExternalSingleTextbox = function mapRespondentSurveyExternalSingleTextbox(externalQuestion) {
  assertRespondentSurvey$6(externalQuestion);
  var layout = externalQuestion.layout,
      validation = externalQuestion.validation,
      required = externalQuestion.required,
      fieldSet = externalQuestion.fieldSet;
  return {
    layout: layout,
    validation: validation,
    required: required,
    fieldSet: fieldSet
  };
}; // Respondent-Survey


var singleTextboxRespondentSurveyMapping = function singleTextboxRespondentSurveyMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'single_textbox'
  }, basicFieldsMapping(externalQuestion)), respondentSurveyMapping(externalQuestion)), mapExternalToInternalSingleTextbox(externalQuestion)), mapRespondentSurveyExternalSingleTextbox(externalQuestion));
}; // Aggregate-Response-Dashboard


var singleTextboxAggregateResponseDashboardMapping = function singleTextboxAggregateResponseDashboardMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread({
    typeId: 'single_textbox'
  }, basicFieldsMapping(externalQuestion)), aggregateResponseDashboardMapping(externalQuestion)), mapExternalToInternalSingleTextbox(externalQuestion));
};
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/** Guard to check properties shared by all capabilities */


var basicExternalMatrixGuards = {
  family: isFixed('MATRIX'),
  variant: isEither([isFixed('SINGLE_ANSWER_RADIO'), isFixed('MANY_ANSWERS_CHECKBOX')])
};

function assertExternalMatrix(externalQuestion) {
  return typeAssertion(basicExternalMatrixGuards)(externalQuestion);
}
/** Map fields shared by all capabilities */


var mapExternalToInternalMatrix = function mapExternalToInternalMatrix(externalQuestion) {
  assertExternalMatrix(externalQuestion);
  var family = externalQuestion.family,
      variant = externalQuestion.variant;
  return {
    family: family,
    variant: variant,
    disabled: false
  };
};
/** Assertion for Respondent-Survey specific properties */


function assertRespondentSurvey$5(u) {
  return typeAssertion(typeGuard({
    fieldSets: isArrayOf(isFieldSet),
    required: isNullable(isEither([isAllAnswerRequired, isAnswerRangeRequired, isAnswerCountPredicateRequired])),
    sorting: isNullable(isQuestionSorting),
    layout: typeGuard({
      placement: isQuestionLayoutPlacement,
      spacing: isQuestionLayoutSpacing,
      width: isQuestionLayoutWidth,
      labelWidthPercent: isOneOf(questionTypeHeaderColumnWidths)
    })
  }))(u);
}
/** Map Respondent-Survey specific properties */


var mapRespondentSurveyExternalMatrix = function mapRespondentSurveyExternalMatrix(externalQuestion) {
  assertRespondentSurvey$5(externalQuestion);
  var layout = externalQuestion.layout,
      fieldSets = externalQuestion.fieldSets,
      required = externalQuestion.required,
      sorting = externalQuestion.sorting;
  return {
    layout: layout,
    fieldSets: fieldSets,
    required: required,
    sorting: sorting
  };
}; // Respondent-Survey


var matrixRespondentSurveyMapping = function matrixRespondentSurveyMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'matrix'
  }, basicFieldsMapping(externalQuestion)), respondentSurveyMapping(externalQuestion)), mapExternalToInternalMatrix(externalQuestion)), mapRespondentSurveyExternalMatrix(externalQuestion));
}; // Aggregate-Response-Dashboard


var matrixAggregateResponseDashboardMapping = function matrixAggregateResponseDashboardMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread({
    typeId: 'matrix'
  }, basicFieldsMapping(externalQuestion)), aggregateResponseDashboardMapping(externalQuestion)), mapExternalToInternalMatrix(externalQuestion));
};
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/** Guard to check properties shared by all capabilities */


var basicExternalMultipleChoiceGuards = {
  family: isFixed('MULTIPLE_CHOICE'),
  variant: isFixed('SINGLE_ANSWER_RADIO')
};
/** Assertion to check properties shared by all capabilities */

function assertExternalMultipleChoice(externalQuestion) {
  return typeAssertion(basicExternalMultipleChoiceGuards)(externalQuestion);
}
/** Map fields shared by all capabilities */


var mapExternalToInternalMultipleChoice = function mapExternalToInternalMultipleChoice(externalQuestion) {
  assertExternalMultipleChoice(externalQuestion);
  var variant = externalQuestion.variant,
      family = externalQuestion.family;
  return {
    variant: variant,
    family: family,
    disabled: false
  };
};
/** Assertion for Respondent-Survey specific properties */


function assertRespondentSurvey$4(u) {
  return typeAssertion(typeGuard(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basicExternalAllMultipleChoiceGuards), basicExternalMultipleChoiceLayoutGuard), basicExternalMultipleChoiceValidationGuard), basicExternalMultipleChoiceAnswersGuard), basicExternalMultipleChoiceAnswerOtherGuard), basicExternalMultipleChoiceAnswerNoneOfTheAboveGuard)))(u);
}
/** Map Respondent-Survey specific properties */


var mapRespondentSurveyExternalMultipleChoice = function mapRespondentSurveyExternalMultipleChoice(externalQuestion) {
  assertRespondentSurvey$4(externalQuestion); // Placeholder - we don't have this visualization yet

  var required = externalQuestion.required,
      layout = externalQuestion.layout,
      validation = externalQuestion.validation,
      answers = externalQuestion.answers,
      answerOther = externalQuestion.answerOther,
      answerNoneOfTheAbove = externalQuestion.answerNoneOfTheAbove;
  return {
    required: required,
    layout: layout,
    validation: validation,
    answers: answers,
    answerOther: answerOther ? _objectSpread(_objectSpread({
      id: answerOther.id,
      label: answerOther.label,
      touched: false,
      value: '',
      selected: false,
      visible: answerOther.visible,
      type: answerOther.type
    }, answerOther.type === 'ANSWER' ? {
      requiredErrorText: answerOther.requiredErrorText
    } : {}), {}, {
      linesCount: answerOther.layout.linesCount,
      charsCount: answerOther.layout.charsCount
    }) : null,
    answerNoneOfTheAbove: answerNoneOfTheAbove
  };
};
/** Assertion for Respondent-Quiz-Results */


function assertRespondentQuizResults(u) {
  return typeAssertion(typeGuard(_objectSpread(_objectSpread(_objectSpread({}, basicExternalMultipleChoiceLayoutGuard), basicExternalMultipleChoiceAnswerOtherGuard), basicExternalMultipleChoiceAnswerNoneOfTheAboveGuard)))(u);
}
/** Map Respondent-Quiz-Results specific properties */


var mapRespondentQuizResultsExternalMultipleChoice = function mapRespondentQuizResultsExternalMultipleChoice(externalQuestion) {
  assertRespondentQuizResults(externalQuestion);
  var layout = externalQuestion.layout,
      answerOther = externalQuestion.answerOther,
      answerNoneOfTheAbove = externalQuestion.answerNoneOfTheAbove;
  return {
    layout: layout,
    answerOther: answerOther ? _objectSpread(_objectSpread({
      id: answerOther.id,
      label: answerOther.label,
      visible: answerOther.visible,
      type: answerOther.type
    }, answerOther.type === 'ANSWER' ? {
      requiredErrorText: answerOther.requiredErrorText
    } : {}), {}, {
      linesCount: answerOther.layout.linesCount,
      charsCount: answerOther.layout.charsCount
    }) : null,
    answerNoneOfTheAbove: answerNoneOfTheAbove ? {
      id: answerNoneOfTheAbove.id,
      label: answerNoneOfTheAbove.label
    } : null
  };
}; // Respondent-Survey


var multipleChoiceRespondentSurveyMapping = function multipleChoiceRespondentSurveyMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'multiple_choice'
  }, basicFieldsMapping(externalQuestion)), respondentSurveyMapping(externalQuestion)), mapExternalToInternalMultipleChoice(externalQuestion)), mapRespondentSurveyExternalMultipleChoice(externalQuestion));
}; // Respondent-Quiz-Results


var multipleChoiceRespondentQuizResultsMapping = function multipleChoiceRespondentQuizResultsMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'multiple_choice'
  }, basicFieldsMapping(externalQuestion)), respondentQuizResultsMapping(externalQuestion)), mapExternalToInternalMultipleChoice(externalQuestion)), mapRespondentQuizResultsExternalMultipleChoice(externalQuestion));
}; // Aggregate-Response-Dashboard


var multipleChoiceAggregateResponseDashboardMapping = function multipleChoiceAggregateResponseDashboardMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread({
    typeId: 'multiple_choice'
  }, basicFieldsMapping(externalQuestion)), aggregateResponseDashboardMapping(externalQuestion)), mapExternalToInternalMultipleChoice(externalQuestion));
};

var basicExternalMultipleTextboxGuards = {
  family: isFixed('OPEN_ENDED'),
  variant: isFixed('MANY_FIELDS')
};

function assertExternalMultipleTextbox(externalQuestion) {
  return typeAssertion(basicExternalMultipleTextboxGuards)(externalQuestion);
}
/** Map external question type */


var mapExternalToInternalMultipleTextbox = function mapExternalToInternalMultipleTextbox(externalQuestion) {
  assertExternalMultipleTextbox(externalQuestion);
  var variant = externalQuestion.variant,
      family = externalQuestion.family;
  return {
    variant: variant,
    family: family,
    disabled: false
  };
};
/** Assertion for Respondent-Survey */


function assertRespondentSurvey$3(u) {
  return typeAssertion({
    fieldSets: isArrayOf(isFieldSet),
    required: isAllAnswerRequired,
    layout: typeGuard({
      placement: isQuestionLayoutPlacement,
      spacing: isQuestionLayoutSpacing,
      width: isQuestionLayoutWidth,
      labelWidthPercent: isNumber,
      charsCount: isNumber
    }),
    sorting: isNullable(isQuestionSorting),
    validation: isNullable(isEither([isSumValidation, isFieldValidation]))
  })(u);
}

var mapRespondentSurveyExternalMultipleTextbox = function mapRespondentSurveyExternalMultipleTextbox(externalQuestion) {
  assertRespondentSurvey$3(externalQuestion);
  var fieldSets = externalQuestion.fieldSets,
      layout = externalQuestion.layout,
      required = externalQuestion.required,
      sorting = externalQuestion.sorting,
      validation = externalQuestion.validation;
  return {
    fieldSets: fieldSets,
    layout: layout,
    required: required,
    validation: validation,
    sorting: sorting
  };
}; // Respondent-Survey


var multipleTextboxRespondentSurveyMapping = function multipleTextboxRespondentSurveyMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'multiple_textbox'
  }, basicFieldsMapping(externalQuestion)), respondentSurveyMapping(externalQuestion)), mapExternalToInternalMultipleTextbox(externalQuestion)), mapRespondentSurveyExternalMultipleTextbox(externalQuestion));
}; // Aggregate-Response-Dashboard


var multipleTextboxAggregateResponseDashboardMapping = function multipleTextboxAggregateResponseDashboardMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread({
    typeId: 'multiple_textbox'
  }, basicFieldsMapping(externalQuestion)), aggregateResponseDashboardMapping(externalQuestion)), mapExternalToInternalMultipleTextbox(externalQuestion));
};

var basicExternalRankingGuards = {
  family: isFixed('RANKING'),
  variant: isFixed('SINGLE_ANSWER_RADIO')
};

function assertExternalRanking(externalQuestion) {
  return typeAssertion(basicExternalRankingGuards)(externalQuestion);
}
/** Map external question type */


var mapExternalToInternalRanking = function mapExternalToInternalRanking(externalQuestion) {
  assertExternalRanking(externalQuestion);
  var family = externalQuestion.family,
      variant = externalQuestion.variant;
  return {
    variant: variant,
    family: family,
    disabled: false
  };
};

var isRankingLayoutOption = typeGuard({
  spacing: isQuestionLayoutSpacing,
  width: isQuestionLayoutWidth,
  labelWidthPercent: isQuestionLayoutHeaderColumnWidth
});
/** Assertion for Respondent-Survey */

function assertRespondentSurvey$2(u) {
  return typeAssertion({
    required: isNullable(isAllAnswerRequired),
    answerNA: isNullable(isAnswerNoneOfTheAbove),
    answersWeighted: isWeightedAnswers,
    fieldSets: isArrayOf(isFieldSet),
    isWeighted: isFixed(true),
    layout: isRankingLayoutOption,
    sorting: isNullable(isQuestionSorting)
  })(u);
}
/** Map the respondent survey fields */


var mapRespondentSurveyExternalRanking = function mapRespondentSurveyExternalRanking(externalQuestion) {
  assertRespondentSurvey$2(externalQuestion);
  var required = externalQuestion.required,
      answerNA = externalQuestion.answerNA,
      answersWeighted = externalQuestion.answersWeighted,
      fieldSets = externalQuestion.fieldSets,
      isWeighted = externalQuestion.isWeighted,
      layout = externalQuestion.layout,
      sorting = externalQuestion.sorting;
  return {
    required: required,
    answerNA: answerNA,
    answersWeighted: answersWeighted,
    fieldSets: fieldSets,
    isWeighted: isWeighted,
    layout: layout,
    sorting: sorting
  };
}; // Respondent-Survey


var rankingRespondentSurveyMapping = function rankingRespondentSurveyMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'ranking'
  }, basicFieldsMapping(externalQuestion)), respondentSurveyMapping(externalQuestion)), mapExternalToInternalRanking(externalQuestion)), mapRespondentSurveyExternalRanking(externalQuestion));
}; // Aggregate-Response-Dashboard


var rankingAggregateResponseDashboardMapping = function rankingAggregateResponseDashboardMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread({
    typeId: 'ranking'
  }, basicFieldsMapping(externalQuestion)), aggregateResponseDashboardMapping(externalQuestion)), mapExternalToInternalRanking(externalQuestion));
};

var isSliderScaleLabels = typeGuard({
  left: isString,
  middle: isOptional(isNullable(isString)),
  right: isString
});
var isScaleOptions = typeGuard({
  minValue: isNumber,
  maxValue: isNumber,
  errorMessage: isString,
  stepSize: isNumber,
  startPosition: isNumber,
  isCustom: isBoolean,
  labels: isSliderScaleLabels
});
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

var basicExternalSliderGuards = {
  family: isFixed('SLIDER'),
  variant: isFixed('SINGLE_SLIDER')
};

function assertExternalSlider(externalQuestion) {
  return typeAssertion(basicExternalSliderGuards)(externalQuestion);
}
/** Map external question type */


var mapExternalToInternalSlider = function mapExternalToInternalSlider(externalQuestion) {
  assertExternalSlider(externalQuestion);
  var family = externalQuestion.family,
      variant = externalQuestion.variant;
  return {
    variant: variant,
    family: family,
    disabled: false
  };
};
/** Assertion for Respondent-Survey */


function assertRespondentSurvey$1(u) {
  return typeAssertion({
    required: isNullable(isAnswerRangeRequired),
    fieldSet: isFieldSet,
    scaleOptions: isScaleOptions,
    hideNumericalInput: isBoolean,
    instructions: isOptional(isString)
  })(u);
}
/** Map the respondent survey fields */


var mapRespondentSurveyExternalSlider = function mapRespondentSurveyExternalSlider(externalQuestion) {
  assertRespondentSurvey$1(externalQuestion);
  var required = externalQuestion.required,
      fieldSet = externalQuestion.fieldSet,
      scaleOptions = externalQuestion.scaleOptions,
      hideNumericalInput = externalQuestion.hideNumericalInput,
      instructions = externalQuestion.instructions;
  return {
    required: required,
    fieldSet: fieldSet,
    scaleOptions: scaleOptions,
    hideNumericalInput: hideNumericalInput,
    instructions: instructions
  };
}; // Respondent-Survey


var sliderRespondentSurveyMapping = function sliderRespondentSurveyMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'slider'
  }, basicFieldsMapping(externalQuestion)), respondentSurveyMapping(externalQuestion)), mapExternalToInternalSlider(externalQuestion)), mapRespondentSurveyExternalSlider(externalQuestion));
}; // Aggregate-Response-Dashboard


var sliderAggregateResponseDashboardMapping = function sliderAggregateResponseDashboardMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread({
    typeId: 'slider'
  }, basicFieldsMapping(externalQuestion)), aggregateResponseDashboardMapping(externalQuestion)), mapExternalToInternalSlider(externalQuestion));
};
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */


var basicExternalStarRatingGuards = {
  family: isFixed('RATING_SCALE'),
  variant: isFixed('SINGLE_ANSWER_SYMBOL')
};

function assertExternalStarRating(externalQuestion) {
  return typeAssertion(basicExternalStarRatingGuards)(externalQuestion);
}
/** Map external question type */


var mapExternalToInternalStarRating = function mapExternalToInternalStarRating(externalQuestion) {
  assertExternalStarRating(externalQuestion);
  var family = externalQuestion.family,
      variant = externalQuestion.variant;
  return {
    variant: variant,
    family: family,
    disabled: false
  };
};

var isRatingScaleSymbolOptions = typeGuard({
  color: isString,
  symbol: isOneOf(ratingScaleSymbols)
});
/** Assertion for Respondent-Survey */

function assertRespondentSurvey(u) {
  return typeAssertion({
    required: isNullable(isAllAnswerRequired),
    fieldSet: isOptional(isFieldSet),
    layout: typeGuard({
      placement: isQuestionLayoutPlacement,
      spacing: isQuestionLayoutSpacing,
      width: isQuestionLayoutWidth
    }),
    answersWeighted: isWeightedAnswers,
    answerNA: isAnswerNoneOfTheAbove,
    answerOther: isAnswerOtherComment,
    sorting: isQuestionSorting,
    symbolOptions: isRatingScaleSymbolOptions
  })(u);
}
/** Map the respondent survey fields */


var mapRespondentSurveyExternalStarRating = function mapRespondentSurveyExternalStarRating(externalQuestion) {
  assertRespondentSurvey(externalQuestion);
  var required = externalQuestion.required,
      fieldSet = externalQuestion.fieldSet,
      layout = externalQuestion.layout,
      answersWeighted = externalQuestion.answersWeighted,
      answerNA = externalQuestion.answerNA,
      answerOther = externalQuestion.answerOther,
      sorting = externalQuestion.sorting,
      symbolOptions = externalQuestion.symbolOptions;
  return {
    required: required,
    fieldSet: fieldSet,
    layout: layout,
    answersWeighted: answersWeighted,
    answerNA: answerNA,
    answerOther: answerOther,
    sorting: sorting,
    symbolOptions: symbolOptions
  };
}; // Respondent-Survey


var starRatingRespondentSurveyMapping = function starRatingRespondentSurveyMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    typeId: 'star_rating'
  }, basicFieldsMapping(externalQuestion)), respondentSurveyMapping(externalQuestion)), mapExternalToInternalStarRating(externalQuestion)), mapRespondentSurveyExternalStarRating(externalQuestion));
}; // Aggregate-Response-Dashboard


var starRatingAggregateResponseDashboardMapping = function starRatingAggregateResponseDashboardMapping(externalQuestion) {
  return _objectSpread(_objectSpread(_objectSpread({
    typeId: 'star_rating'
  }, basicFieldsMapping(externalQuestion)), aggregateResponseDashboardMapping(externalQuestion)), mapExternalToInternalStarRating(externalQuestion));
};
/* eslint-disable @typescript-eslint/naming-convention */


var invalidCombination = function invalidCombination() {
  throw new Error('Invalid question and capability combination');
};
/**
 * Main mapping to resolve QuestionType and Capability to
 * a mapping (and in it the assertion)
 */


var questionTypeAndCapabilityMapping = {
  single_textbox: {
    'respondent-survey': singleTextboxRespondentSurveyMapping,
    'respondent-quiz-results': invalidCombination,
    'aggregate-response-dashboard': singleTextboxAggregateResponseDashboardMapping
  },
  comment_box: {
    'respondent-survey': commentBoxRespondentSurveyMapping,
    'respondent-quiz-results': invalidCombination,
    'aggregate-response-dashboard': commentBoxAggregateResponseDashboardMapping
  },
  multiple_textbox: {
    'respondent-survey': multipleTextboxRespondentSurveyMapping,
    'respondent-quiz-results': invalidCombination,
    'aggregate-response-dashboard': multipleTextboxAggregateResponseDashboardMapping
  },
  check_box: {
    'respondent-survey': checkBoxRespondentSurveyMapping,
    'respondent-quiz-results': checkBoxRespondentQuizResultsMapping,
    'aggregate-response-dashboard': checkBoxAggregateResponseDashboardMapping
  },
  image_choice: {
    'respondent-survey': imageChoiceRespondentSurveyMapping,
    'respondent-quiz-results': imageChoiceRespondentQuizResultsMapping,
    'aggregate-response-dashboard': imageChoiceAggregateResponseDashboardMapping
  },
  multiple_choice: {
    'respondent-survey': multipleChoiceRespondentSurveyMapping,
    'respondent-quiz-results': multipleChoiceRespondentQuizResultsMapping,
    'aggregate-response-dashboard': multipleChoiceAggregateResponseDashboardMapping
  },
  dropdown: {
    'respondent-survey': dropdownRespondentSurveyMapping,
    'respondent-quiz-results': dropdownRespondentQuizResultsMapping,
    'aggregate-response-dashboard': dropdownAggregateResponseDashboardMapping
  },
  slider: {
    'respondent-survey': sliderRespondentSurveyMapping,
    'respondent-quiz-results': invalidCombination,
    'aggregate-response-dashboard': sliderAggregateResponseDashboardMapping
  },
  star_rating: {
    'respondent-survey': starRatingRespondentSurveyMapping,
    'respondent-quiz-results': invalidCombination,
    'aggregate-response-dashboard': starRatingAggregateResponseDashboardMapping
  },
  ranking: {
    'respondent-survey': rankingRespondentSurveyMapping,
    'respondent-quiz-results': invalidCombination,
    'aggregate-response-dashboard': rankingAggregateResponseDashboardMapping
  },
  matrix: {
    'respondent-survey': matrixRespondentSurveyMapping,
    'respondent-quiz-results': invalidCombination,
    'aggregate-response-dashboard': matrixAggregateResponseDashboardMapping
  }
};
/** type guard to check if string is a capability */

var isCapability = function isCapability(u) {
  return CAPABILITIES.includes(u);
};
/** Used to dynamically map the fields base on
 * * typeId
 * * question type
 * * capability
 * * combination of question type and capability
 */


var mapDynamic = function mapDynamic(_ref5) {
  var typeId = _ref5.typeId,
      capability = _ref5.capability,
      externalQuestion = _ref5.externalQuestion;

  if (!isCapability(capability)) {
    // if this is a custom (unknown) capability just return the `externalQuestion` for now
    return externalQuestion;
  }

  return questionTypeAndCapabilityMapping[typeId][capability](externalQuestion);
};

var mapInternalDynamicToExternal = function mapInternalDynamicToExternal(externalQuestion, q, // eslint-disable-next-line @typescript-eslint/no-unused-vars
capability // keep for future use
) {
  // possibly mirror `mapDynamic`s setup if needed later
  // remove internal `typeId` from exported type
  var typeId = externalQuestion.typeId,
      cleanExternalQuestion = _objectWithoutProperties(externalQuestion, ["typeId"]);

  return _objectSpread(_objectSpread({}, cleanExternalQuestion), {}, {
    errors: q && 'errors' in q && q.errors ? q.errors.slice() : []
  });
};

var baseGuards$9 = baseQuestionGuards('single_textbox', 'OPEN_ENDED', 'SINGLE_LINE');
var isQuestionTypeSingleTextbox = typeGuard(baseGuards$9);

function assertQuestionTypeSingleTextbox(q) {
  return typeAssertion(baseGuards$9)(q);
}

var mapFromExternalQuestion$a = function mapFromExternalQuestion$a(externalQuestion, capability) {
  var questionType = mapDynamic({
    typeId: 'single_textbox',
    externalQuestion: externalQuestion,
    capability: capability
  });
  assertQuestionTypeSingleTextbox(questionType);
  return questionType;
};

var appendError = function appendError(q, id, field, type, invalidAnswerMessage) {
  return _objectSpread(_objectSpread({}, q), {}, {
    errors: [].concat(_toConsumableArray((q.errors || []).filter(function (error) {
      return error.id !== id;
    })), [{
      type: type,
      id: id,
      field: field,
      message: invalidAnswerMessage
    }])
  });
};
/** Converts the external `family` and `variant` to the internally used `TypeId` */


var getTypeId = function getTypeId(_ref6) {
  var family = _ref6.family,
      variant = _ref6.variant;

  switch (family) {
    case 'OPEN_ENDED':
      switch (variant) {
        case 'SINGLE_LINE':
          return 'single_textbox';

        case 'ESSAY':
          return 'comment_box';

        case 'MANY_FIELDS':
          return 'multiple_textbox';

        default:
          return null;
      }

    case 'MULTIPLE_CHOICE':
      switch (variant) {
        case 'SINGLE_ANSWER_RADIO':
          return 'multiple_choice';

        case 'MANY_ANSWERS_CHECKBOX':
          return 'check_box';

        case 'SINGLE_ANSWER_IMAGE':
          return 'image_choice_single_answer';
        // TODO: RAWR-627 combine with image_choice_single_answer

        case 'MANY_ANSWERS_IMAGE':
          return 'image_choice_many_answers';
        // TODO: RAWR-627 combine with image_choice_single_answer

        case 'SINGLE_ANSWER_MENU':
          return 'dropdown';

        default:
          return null;
      }

    case 'SLIDER':
      switch (variant) {
        case 'SINGLE_SLIDER':
          return 'slider';

        default:
          return null;
      }

    case 'RATING_SCALE':
      switch (variant) {
        case 'SINGLE_ANSWER_SYMBOL':
          return 'star_rating';

        default:
          return null;
      }

    case 'MATRIX':
      switch (variant) {
        case 'SINGLE_ANSWER_RADIO':
          return 'matrix';

        case 'MANY_ANSWERS_CHECKBOX':
          return 'matrix';

        default:
          return null;
      }

    case 'RANKING':
      switch (variant) {
        case 'SINGLE_ANSWER_RADIO':
          return 'ranking';

        default:
          return null;
      }

    default:
      return null;
  }
};

var DATE_PATTERNS = {
  DATE_INTL: /(((0|1)[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/((19|20)\d\d))$/,
  DATE_US: /(0[1-9]|1[0-2])\/(((0|1)[0-9]|2[0-9]|3[0-1])\/((19|20)\d\d))$/
};
var DATE_BUILDERS = {
  DATE_INTL: function DATE_INTL(_ref7) {
    var _ref8 = _slicedToArray2(_ref7, 3),
        dd = _ref8[0],
        mm = _ref8[1],
        yyyy = _ref8[2];

    return new Date(yyyy, mm - 1, dd);
  },
  DATE_US: function DATE_US(_ref9) {
    var _ref10 = _slicedToArray2(_ref9, 3),
        mm = _ref10[0],
        dd = _ref10[1],
        yyyy = _ref10[2];

    return new Date(yyyy, mm - 1, dd);
  }
}; // TODO: see if we can move part of these functions's code to the generic
// question utils, leaving just what's specific to SingleTextbox.
// Try to do it in a way that preserves the versatility
// and the simplicity of their implementation

var checkValueTextLength$4 = function checkValueTextLength$4(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answer = q.answer;

  if (validation && validation.type === 'TEXT_LENGTH' && answer && answer.touched) {
    // TODO: check if these fields are enough to help render the error messages properly
    var field = q.id;
    var id = "text-length:".concat(q.id);
    var minLength = validation.minLength,
        maxLength = validation.maxLength,
        errorMessage = validation.errorMessage;

    if (answer.value.length > maxLength || answer.value.length < minLength) {
      return appendError(q, id, field, 'local-error', errorMessage);
    }
  }

  return q;
};

var strToDate$3 = function strToDate$3(format) {
  return function (s) {
    return DATE_PATTERNS[format].test(s) ? DATE_BUILDERS[format](s.split('/').map(Number)) : null;
  };
};

var checkValueDateFormat$3 = function checkValueDateFormat$3(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answer = q.answer;

  if (validation && (validation.type === 'DATE_INTL' || validation.type === 'DATE_US') && answer && answer.touched) {
    // TODO: check if these fields are enough to help render the error messages properly
    var field = q.id;
    var id = "date-format:".concat(q.id);
    var minDate = validation.minDate,
        maxDate = validation.maxDate,
        errorMessage = validation.errorMessage;
    var value = answer.value;

    var _map = [minDate, maxDate, value].map(strToDate$3(validation.type)),
        _map2 = _slicedToArray2(_map, 3),
        dmin = _map2[0],
        dmax = _map2[1],
        date = _map2[2];

    if (!date || dmax && date.getTime() > dmax.getTime() || dmin && date.getTime() < dmin.getTime()) {
      return appendError(q, id, field, 'local-error', errorMessage);
    }
  }

  return q;
};

var validators$4 = {
  any: [checkValueTextLength$4, checkValueDateFormat$3]
};

var validate$b = function validate$b(q) {
  var capability = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'any';
  var filteredValidators = validators$4[capability] || [];
  return filteredValidators.reduce(function (state, validator) {
    return validator(state);
  }, q);
}; // standard interface for QuestionType to convert to and from


var typeId$9 = 'single_textbox';

var fromExternalQuestion$a = function fromExternalQuestion$a(source, capability) {
  return mapFromExternalQuestion$a(source, capability);
};

var toExternalQuestion$a = function toExternalQuestion$a(eq, q, capability) {
  return mapInternalDynamicToExternal(eq, q);
};

var shortUpdate$a = function shortUpdate$a(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'partial-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  // example of short update usage logic:
  // if there's an error in the error list, run local validations on the question
  if (capability === 'any' && updateType === 'partial-value-change' && 'errors' in q && q.errors.length > 0) {
    return validate$b(q, capability);
  }

  return q;
}; // TODO: evaluate if long updates need to be async


var longUpdate$a = function longUpdate$a(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (capability === 'any' && updateType === 'full-value-change') {
    return validate$b(q, capability);
  }

  return q;
};
/** isCompatible
 * -------------
 * detects if a question belongs to this question type
 * this function is supposed to be as optimized as posssible as it will run multiple times
 * Question Types are supposed to have a versatile way of identifying
 */


var isCompatible$a = function isCompatible$a(q) {
  return isExternalQuestionWithTypeId(q) && q.typeId === typeId$9;
};

var isOfQuestionType$a = isQuestionTypeSingleTextbox;
var assertQuestionType$a = assertQuestionTypeSingleTextbox; // SingleTextbox Type Definition -- this will change as we learn more

var singleTextboxQuestionDefinition = {
  typeId: typeId$9,
  shortUpdate: shortUpdate$a,
  longUpdate: longUpdate$a,
  validate: validate$b,
  fromExternalQuestion: fromExternalQuestion$a,
  toExternalQuestion: toExternalQuestion$a,
  isOfQuestionType: isOfQuestionType$a,
  isCompatible: isCompatible$a,
  assertQuestionType: assertQuestionType$a
};
var baseGuards$8 = baseQuestionGuards('multiple_textbox', 'OPEN_ENDED', 'MANY_FIELDS');
var isQuestionTypeMultipleTextbox = typeGuard(baseGuards$8);

function assertQuestionTypeMultipleTextbox(q) {
  return typeAssertion(baseGuards$8)(q);
}

var mapFromExternalQuestion$9 = function mapFromExternalQuestion$9(externalQuestion, capability) {
  var questionType = mapDynamic({
    typeId: 'multiple_textbox',
    externalQuestion: externalQuestion,
    capability: capability
  });
  assertQuestionTypeMultipleTextbox(questionType);
  return questionType;
};

var validate$a = function validate$a(question) {
  return question;
}; // standard interface for QuestionType to convert to and from


var typeId$8 = 'multiple_textbox';

var fromExternalQuestion$9 = function fromExternalQuestion$9(source, capability) {
  return mapFromExternalQuestion$9(source, capability);
};

var toExternalQuestion$9 = function toExternalQuestion$9(eq, q, capability) {
  return mapInternalDynamicToExternal(eq, q);
};

var shortUpdate$9 = function shortUpdate$9(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'partial-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  // example of short update usage logic:
  // if there's an error in the error list, run local validations on the question
  if (capability === 'any' && updateType === 'partial-value-change' && 'errors' in q && q.errors.length > 0) {
    return validate$a(q);
  }

  return q;
}; // TODO: evaluate if long updates need to be async


var longUpdate$9 = function longUpdate$9(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (capability === 'any' && updateType === 'full-value-change') {
    return validate$a(q);
  }

  return q;
};
/** isCompatible
 * -------------
 * detects if a question belongs to this question type
 * this function is supposed to be as optimized as posssible as it will run multiple times
 * Question Types are supposed to have a versatile way of identifying
 */


var isCompatible$9 = function isCompatible$9(q) {
  return isExternalQuestionWithTypeId(q) && q.typeId === typeId$8;
};

var isOfQuestionType$9 = isQuestionTypeMultipleTextbox;
var assertQuestionType$9 = assertQuestionTypeMultipleTextbox;
var multipleTextboxQuestionDefinition = {
  typeId: typeId$8,
  shortUpdate: shortUpdate$9,
  longUpdate: longUpdate$9,
  validate: validate$a,
  fromExternalQuestion: fromExternalQuestion$9,
  toExternalQuestion: toExternalQuestion$9,
  isOfQuestionType: isOfQuestionType$9,
  isCompatible: isCompatible$9,
  assertQuestionType: assertQuestionType$9
}; /// Type Guards

var baseGuards$7 = baseQuestionGuards('comment_box', 'OPEN_ENDED', 'ESSAY');
var isQuestionTypeCommentBox = typeGuard(baseGuards$7);

function assertQuestionTypeCommentBox(q) {
  return typeAssertion(baseGuards$7)(q);
} // TODO: see if we can move part of these functions's code to the generic
// question utils, leaving just what's specific to SingleTextbox.
// Try to do it in a way that preserves the versatility
// and the simplicity of their implementation


var checkValueTextLength$3 = function checkValueTextLength$3(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answer = q.answer;

  if (validation && validation.type === 'TEXT_LENGTH' && answer && answer.touched) {
    // TODO: check if these fields are enough to help render the error messages properly
    var field = q.id;
    var id = "text-length:".concat(q.id);
    var minLength = validation.minLength,
        maxLength = validation.maxLength,
        errorMessage = validation.errorMessage;

    if (answer.value.length > maxLength || answer.value.length < minLength) {
      return appendError(q, id, field, 'local-error', errorMessage);
    }
  }

  return q;
};

var validators$3 = [checkValueTextLength$3];

var validate$9 = function validate$9(q) {
  return validators$3.reduce(function (state, validator) {
    return validator(state);
  }, q);
};

var mapFromExternalQuestion$8 = function mapFromExternalQuestion$8(externalQuestion, capability) {
  var questionType = mapDynamic({
    typeId: 'comment_box',
    externalQuestion: externalQuestion,
    capability: capability
  });
  assertQuestionTypeCommentBox(questionType);
  return questionType;
}; // standard interface for QuestionType to convert to and from
// the External Generic QuestionType


var typeId$7 = 'comment_box';

var fromExternalQuestion$8 = function fromExternalQuestion$8(source, capability) {
  return mapFromExternalQuestion$8(source, capability);
};

var toExternalQuestion$8 = function toExternalQuestion$8(eq, q, capability) {
  return mapInternalDynamicToExternal(eq, q);
};

var shortUpdate$8 = function shortUpdate$8(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'partial-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  // example of short update usage logic:
  // if there's an error in the error list, run local validations on the question
  if (capability === 'any' && updateType === 'partial-value-change' && 'errors' in q && q.errors.length > 0) {
    return validate$9(q);
  }

  return q;
}; // TODO: evaluate if long updates need to be async


var longUpdate$8 = function longUpdate$8(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (capability === 'any' && updateType === 'full-value-change') {
    return validate$9(q);
  }

  return q;
};

var isCompatible$8 = function isCompatible$8(q) {
  return isExternalQuestionWithTypeId(q) && q.typeId === typeId$7;
};

var isOfQuestionType$8 = isQuestionTypeCommentBox;
var assertQuestionType$8 = assertQuestionTypeCommentBox;
var commentBoxQuestionDefinition = {
  typeId: typeId$7,
  shortUpdate: shortUpdate$8,
  longUpdate: longUpdate$8,
  validate: validate$9,
  fromExternalQuestion: fromExternalQuestion$8,
  toExternalQuestion: toExternalQuestion$8,
  isCompatible: isCompatible$8,
  isOfQuestionType: isOfQuestionType$8,
  assertQuestionType: assertQuestionType$8
}; /// Type Guards

var baseGuards$6 = baseQuestionGuards('multiple_choice', 'MULTIPLE_CHOICE', 'SINGLE_ANSWER_RADIO');
var isQuestionValidationMultipleChoice = isFieldValidation;
var isQuestionTypeMultipleChoice = typeGuard(baseGuards$6);

function assertQuestionTypeMultipleChoice(q) {
  return typeAssertion(baseGuards$6)(q);
}

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}

var assertString_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = assertString;

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function assertString(input) {
    var isString = typeof input === 'string' || input instanceof String;

    if (!isString) {
      var invalidType = _typeof(input);

      if (input === null) invalidType = 'null';else if (invalidType === 'object') invalidType = input.constructor.name;
      throw new TypeError("Expected a string but received a ".concat(invalidType));
    }
  }

  module.exports = exports["default"];
  module.exports["default"] = exports["default"];
});
var merge_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = merge;

  function merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;

    for (var key in defaults) {
      if (typeof obj[key] === 'undefined') {
        obj[key] = defaults[key];
      }
    }

    return obj;
  }

  module.exports = exports["default"];
  module.exports["default"] = exports["default"];
});
var isByteLength_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isByteLength;

  var _assertString = _interopRequireDefault(assertString_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }
  /* eslint-disable prefer-rest-params */


  function isByteLength(str, options) {
    (0, _assertString["default"])(str);
    var min;
    var max;

    if (_typeof(options) === 'object') {
      min = options.min || 0;
      max = options.max;
    } else {
      // backwards compatibility: isByteLength(str, min [, max])
      min = arguments[1];
      max = arguments[2];
    }

    var len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === 'undefined' || len <= max);
  }

  module.exports = exports["default"];
  module.exports["default"] = exports["default"];
});
var isFQDN_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isFQDN;

  var _assertString = _interopRequireDefault(assertString_1);

  var _merge = _interopRequireDefault(merge_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_numeric_tld: false
  };

  function isFQDN(str, options) {
    (0, _assertString["default"])(str);
    options = (0, _merge["default"])(options, default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */

    if (options.allow_trailing_dot && str[str.length - 1] === '.') {
      str = str.substring(0, str.length - 1);
    }

    var parts = str.split('.');
    var tld = parts[parts.length - 1];

    if (options.require_tld) {
      // disallow fqdns without tld
      if (parts.length < 2) {
        return false;
      }

      if (!/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
        return false;
      } // disallow spaces && special characers


      if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20\u00A9\uFFFD]/.test(tld)) {
        return false;
      }
    } // reject numeric TLDs


    if (!options.allow_numeric_tld && /^\d+$/.test(tld)) {
      return false;
    }

    return parts.every(function (part) {
      if (part.length > 63) {
        return false;
      }

      if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) {
        return false;
      } // disallow full-width chars


      if (/[\uff01-\uff5e]/.test(part)) {
        return false;
      } // disallow parts starting or ending with hyphen


      if (/^-|-$/.test(part)) {
        return false;
      }

      if (!options.allow_underscores && /_/.test(part)) {
        return false;
      }

      return true;
    });
  }

  module.exports = exports["default"];
  module.exports["default"] = exports["default"];
});
var isIP_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isIP;

  var _assertString = _interopRequireDefault(assertString_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  /**
  11.3.  Examples
  
     The following addresses
  
               fe80::1234 (on the 1st link of the node)
               ff02::5678 (on the 5th link of the node)
               ff08::9abc (on the 10th organization of the node)
  
     would be represented as follows:
  
               fe80::1234%1
               ff02::5678%5
               ff08::9abc%10
  
     (Here we assume a natural translation from a zone index to the
     <zone_id> part, where the Nth zone of any scope is translated into
     "N".)
  
     If we use interface names as <zone_id>, those addresses could also be
     represented as follows:
  
              fe80::1234%ne0
              ff02::5678%pvc1.3
              ff08::9abc%interface10
  
     where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
     to the 5th link, and "interface10" belongs to the 10th organization.
   * * */


  var ipv4Maybe = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
  var ipv6Block = /^[0-9A-F]{1,4}$/i;

  function isIP(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (0, _assertString["default"])(str);
    version = String(version);

    if (!version) {
      return isIP(str, 4) || isIP(str, 6);
    } else if (version === '4') {
      if (!ipv4Maybe.test(str)) {
        return false;
      }

      var parts = str.split('.').sort(function (a, b) {
        return a - b;
      });
      return parts[3] <= 255;
    } else if (version === '6') {
      var addressAndZone = [str]; // ipv6 addresses could have scoped architecture
      // according to https://tools.ietf.org/html/rfc4007#section-11

      if (str.includes('%')) {
        addressAndZone = str.split('%');

        if (addressAndZone.length !== 2) {
          // it must be just two parts
          return false;
        }

        if (!addressAndZone[0].includes(':')) {
          // the first part must be the address
          return false;
        }

        if (addressAndZone[1] === '') {
          // the second part must not be empty
          return false;
        }
      }

      var blocks = addressAndZone[0].split(':');
      var foundOmissionBlock = false; // marker to indicate ::
      // At least some OS accept the last 32 bits of an IPv6 address
      // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
      // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
      // and '::a.b.c.d' is deprecated, but also valid.

      var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
      var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

      if (blocks.length > expectedNumberOfBlocks) {
        return false;
      } // initial or final ::


      if (str === '::') {
        return true;
      } else if (str.substr(0, 2) === '::') {
        blocks.shift();
        blocks.shift();
        foundOmissionBlock = true;
      } else if (str.substr(str.length - 2) === '::') {
        blocks.pop();
        blocks.pop();
        foundOmissionBlock = true;
      }

      for (var i = 0; i < blocks.length; ++i) {
        // test for a :: which can not be at the string start/end
        // since those cases have been handled above
        if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
          if (foundOmissionBlock) {
            return false; // multiple :: in address
          }

          foundOmissionBlock = true;
        } else if (foundIPv4TransitionBlock && i === blocks.length - 1) ;else if (!ipv6Block.test(blocks[i])) {
          return false;
        }
      }

      if (foundOmissionBlock) {
        return blocks.length >= 1;
      }

      return blocks.length === expectedNumberOfBlocks;
    }

    return false;
  }

  module.exports = exports["default"];
  module.exports["default"] = exports["default"];
});
var isEmail_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isEmail;

  var _assertString = _interopRequireDefault(assertString_1);

  var _merge = _interopRequireDefault(merge_1);

  var _isByteLength = _interopRequireDefault(isByteLength_1);

  var _isFQDN = _interopRequireDefault(isFQDN_1);

  var _isIP = _interopRequireDefault(isIP_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  var default_email_options = {
    allow_display_name: false,
    require_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true,
    blacklisted_chars: '',
    ignore_max_length: false
  };
  /* eslint-disable max-len */

  /* eslint-disable no-control-regex */

  var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)<(.+)>$/i;
  var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
  var gmailUserPart = /^[a-z\d]+$/;
  var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
  var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
  var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
  var defaultMaxEmailLength = 254;
  /* eslint-enable max-len */

  /* eslint-enable no-control-regex */

  /**
   * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
   * @param {String} display_name
   */

  function validateDisplayName(display_name) {
    var trim_quotes = display_name.match(/^"(.+)"$/i);
    var display_name_without_quotes = trim_quotes ? trim_quotes[1] : display_name; // display name with only spaces is not valid

    if (!display_name_without_quotes.trim()) {
      return false;
    } // check whether display name contains illegal character


    var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);

    if (contains_illegal) {
      // if contains illegal characters,
      // must to be enclosed in double-quotes, otherwise it's not a valid display name
      if (!trim_quotes) {
        return false;
      } // the quotes in display name must start with character symbol \


      var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;

      if (!all_start_with_back_slash) {
        return false;
      }
    }

    return true;
  }

  function isEmail(str, options) {
    (0, _assertString["default"])(str);
    options = (0, _merge["default"])(options, default_email_options);

    if (options.require_display_name || options.allow_display_name) {
      var display_email = str.match(splitNameAddress);

      if (display_email) {
        var display_name;

        var _display_email = _slicedToArray(display_email, 3);

        display_name = _display_email[1];
        str = _display_email[2]; // sometimes need to trim the last space to get the display name
        // because there may be a space between display name and email address
        // eg. myname <address@gmail.com>
        // the display name is `myname` instead of `myname `, so need to trim the last space

        if (display_name.endsWith(' ')) {
          display_name = display_name.substr(0, display_name.length - 1);
        }

        if (!validateDisplayName(display_name)) {
          return false;
        }
      } else if (options.require_display_name) {
        return false;
      }
    }

    if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
      return false;
    }

    var parts = str.split('@');
    var domain = parts.pop();
    var user = parts.join('@');
    var lower_domain = domain.toLowerCase();

    if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
      /*
        Previously we removed dots for gmail addresses before validating.
        This was removed because it allows `multiple..dots@gmail.com`
        to be reported as valid, but it is not.
        Gmail only normalizes single dots, removing them from here is pointless,
        should be done in normalizeEmail
      */
      user = user.toLowerCase(); // Removing sub-address from username before gmail validation

      var username = user.split('+')[0]; // Dots are not included in gmail length restriction

      if (!(0, _isByteLength["default"])(username.replace('.', ''), {
        min: 6,
        max: 30
      })) {
        return false;
      }

      var _user_parts = username.split('.');

      for (var i = 0; i < _user_parts.length; i++) {
        if (!gmailUserPart.test(_user_parts[i])) {
          return false;
        }
      }
    }

    if (options.ignore_max_length === false && (!(0, _isByteLength["default"])(user, {
      max: 64
    }) || !(0, _isByteLength["default"])(domain, {
      max: 254
    }))) {
      return false;
    }

    if (!(0, _isFQDN["default"])(domain, {
      require_tld: options.require_tld
    })) {
      if (!options.allow_ip_domain) {
        return false;
      }

      if (!(0, _isIP["default"])(domain)) {
        if (!domain.startsWith('[') || !domain.endsWith(']')) {
          return false;
        }

        var noBracketdomain = domain.substr(1, domain.length - 2);

        if (noBracketdomain.length === 0 || !(0, _isIP["default"])(noBracketdomain)) {
          return false;
        }
      }
    }

    if (user[0] === '"') {
      user = user.slice(1, user.length - 1);
      return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
    }

    var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
    var user_parts = user.split('.');

    for (var _i2 = 0; _i2 < user_parts.length; _i2++) {
      if (!pattern.test(user_parts[_i2])) {
        return false;
      }
    }

    if (options.blacklisted_chars) {
      if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
    }

    return true;
  }

  module.exports = exports["default"];
  module.exports["default"] = exports["default"];
});
var isEmail = /*@__PURE__*/getDefaultExportFromCjs(isEmail_1); // TODO: see if we can move part of these functions's code to the generic
// question utils, leaving just what's specific to SingleTextbox.
// Try to do it in a way that preserves the versatility
// and the simplicity of their implementation

var checkValueTextLength$2 = function checkValueTextLength$2(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answerOther = q.answerOther;

  if (validation && validation.type === 'TEXT_LENGTH' && answerOther && answerOther.touched) {
    // TODO: check if these fields are enough to help render the error messages properly
    var field = q.id;
    var id = "text-length:".concat(q.id);
    var minLength = validation.minLength,
        maxLength = validation.maxLength,
        errorMessage = validation.errorMessage;

    if (answerOther.value.length > maxLength || answerOther.value.length < minLength) {
      return appendError(q, id, field, 'local-error', errorMessage);
    }
  }

  return q;
};

var strToDate$2 = function strToDate$2(format) {
  return function (s) {
    return DATE_PATTERNS[format].test(s) ? DATE_BUILDERS[format](s.split('/').map(Number)) : null;
  };
};

var checkValueDateFormat$2 = function checkValueDateFormat$2(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answerOther = q.answerOther;

  if (validation && (validation.type === 'DATE_INTL' || validation.type === 'DATE_US') && answerOther && answerOther.touched) {
    // TODO: check if these fields are enough to help render the error messages properly
    var field = q.id;
    var id = "date-format:".concat(q.id);
    var minDate = validation.minDate,
        maxDate = validation.maxDate,
        errorMessage = validation.errorMessage;
    var value = answerOther.value;

    var _map3 = [minDate, maxDate, value].map(strToDate$2(validation.type)),
        _map4 = _slicedToArray2(_map3, 3),
        dmin = _map4[0],
        dmax = _map4[1],
        date = _map4[2];

    if (!date || dmax && date.getTime() > dmax.getTime() || dmin && date.getTime() < dmin.getTime()) {
      return appendError(q, id, field, 'local-error', errorMessage);
    }
  }

  return q;
};

var checkValueNumber$2 = function checkValueNumber$2(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answerOther = q.answerOther;
  var id = "integer:".concat(q.id);
  var field = q.id;

  if (validation && (validation.type === 'INTEGER' || validation.type === 'DECIMAL') && answerOther && answerOther.touched) {
    var numInt = parseInt(answerOther.value, 10);

    if (Number.isNaN(numInt) && Math.floor(numInt) === numInt && numInt >= validation.minValue && numInt <= validation.maxValue) {
      return q;
    }

    return appendError(q, id, field, 'local-error', validation.errorMessage);
  }

  return q;
};

var checkValueEmail$2 = function checkValueEmail$2(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answerOther = q.answerOther;

  if (validation && validation.type === 'EMAIL' && answerOther && answerOther.touched) {
    var id = "email:".concat(q.id);
    var field = q.id;

    if (!isEmail(answerOther.value)) {
      return appendError(q, id, field, 'local-error', validation.errorMessage);
    }
  }

  return q;
};

var validators$2 = [checkValueTextLength$2, checkValueDateFormat$2, checkValueNumber$2, checkValueEmail$2];

var validate$8 = function validate$8(question) {
  return validators$2.reduce(function (state, validator) {
    return validator(state);
  }, question);
};

var mapFromExternalQuestion$7 = function mapFromExternalQuestion$7(externalQuestion, capability) {
  var questionType = mapDynamic({
    typeId: 'multiple_choice',
    externalQuestion: externalQuestion,
    capability: capability
  });
  assertQuestionTypeMultipleChoice(questionType);
  return questionType;
}; // standard interface for QuestionType to convert to and from
// the External Generic QuestionType


var typeId$6 = 'multiple_choice';

var fromExternalQuestion$7 = function fromExternalQuestion$7(source, capability) {
  return mapFromExternalQuestion$7(source, capability);
};

var toExternalQuestion$7 = function toExternalQuestion$7(eq, q, capability) {
  return mapInternalDynamicToExternal(eq, q);
};

var shortUpdate$7 = function shortUpdate$7(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'partial-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  // example of short update usage logic:
  // if there's an error in the error list, run local validations on the question
  if (capability === 'any' && updateType === 'partial-value-change' && 'errors' in q && q.errors.length > 0) {
    return validate$8(q);
  }

  return q;
}; // TODO: evaluate if long updates need to be async


var longUpdate$7 = function longUpdate$7(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (capability === 'any' && updateType === 'full-value-change') {
    return validate$8(q);
  }

  return q;
};

var isCompatible$7 = function isCompatible$7(q) {
  return isExternalQuestionWithTypeId(q) && q.typeId === typeId$6;
};

var isOfQuestionType$7 = isQuestionTypeMultipleChoice;
var assertQuestionType$7 = assertQuestionTypeMultipleChoice;
var multipleChoiceQuestionDefinition = {
  typeId: typeId$6,
  shortUpdate: shortUpdate$7,
  longUpdate: longUpdate$7,
  validate: validate$8,
  fromExternalQuestion: fromExternalQuestion$7,
  toExternalQuestion: toExternalQuestion$7,
  isCompatible: isCompatible$7,
  isOfQuestionType: isOfQuestionType$7,
  assertQuestionType: assertQuestionType$7
}; // TypeGuards and Assertions

var baseGuards$5 = baseQuestionGuards('check_box', 'MULTIPLE_CHOICE', 'MANY_ANSWERS_CHECKBOX');
var isQuestionTypeCheckBox = typeGuard(baseGuards$5);

function assertQuestionTypeCheckBox(externalQuestion) {
  return typeAssertion(baseGuards$5)(externalQuestion);
}

var mapFromExternalQuestion$6 = function mapFromExternalQuestion$6(externalQuestion, capability) {
  var questionType = mapDynamic({
    typeId: 'check_box',
    externalQuestion: externalQuestion,
    capability: capability
  });
  assertQuestionTypeCheckBox(questionType);
  return questionType;
}; // TODO: see if we can move part of these functions's code to the generic
// question utils, leaving just what's specific to SingleTextbox.
// Try to do it in a way that preserves the versatility
// and the simplicity of their implementation


var checkValueTextLength$1 = function checkValueTextLength$1(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answerOther = q.answerOther;

  if (validation && validation.type === 'TEXT_LENGTH' && answerOther && answerOther.touched) {
    // TODO: check if these fields are enough to help render the error messages properly
    var field = q.id;
    var id = "text-length:".concat(q.id);
    var minLength = validation.minLength,
        maxLength = validation.maxLength,
        errorMessage = validation.errorMessage;

    if (answerOther.value.length > maxLength || answerOther.value.length < minLength) {
      return appendError(q, id, field, 'local-error', errorMessage);
    }
  }

  return q;
};

var strToDate$1 = function strToDate$1(format) {
  return function (s) {
    return DATE_PATTERNS[format].test(s) ? DATE_BUILDERS[format](s.split('/').map(Number)) : null;
  };
};

var checkValueDateFormat$1 = function checkValueDateFormat$1(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answerOther = q.answerOther;

  if (validation && (validation.type === 'DATE_INTL' || validation.type === 'DATE_US') && answerOther && answerOther.touched) {
    // TODO: check if these fields are enough to help render the error messages properly
    var field = q.id;
    var id = "date-format:".concat(q.id);
    var minDate = validation.minDate,
        maxDate = validation.maxDate,
        errorMessage = validation.errorMessage;
    var value = answerOther.value;

    var _map5 = [minDate, maxDate, value].map(strToDate$1(validation.type)),
        _map6 = _slicedToArray2(_map5, 3),
        dmin = _map6[0],
        dmax = _map6[1],
        date = _map6[2];

    if (!date || dmax && date.getTime() > dmax.getTime() || dmin && date.getTime() < dmin.getTime()) {
      return appendError(q, id, field, 'local-error', errorMessage);
    }
  }

  return q;
};

var checkValueNumber$1 = function checkValueNumber$1(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answerOther = q.answerOther;
  var id = "integer:".concat(q.id);
  var field = q.id;

  if (validation && (validation.type === 'INTEGER' || validation.type === 'DECIMAL') && answerOther && answerOther.touched) {
    var numInt = parseInt(answerOther.value, 10);

    if (Number.isNaN(numInt) && Math.floor(numInt) === numInt && numInt >= validation.minValue && numInt <= validation.maxValue) {
      return q;
    }

    return appendError(q, id, field, 'local-error', validation.errorMessage);
  }

  return q;
};

var checkValueEmail$1 = function checkValueEmail$1(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answerOther = q.answerOther;

  if (validation && validation.type === 'EMAIL' && answerOther && answerOther.touched) {
    var id = "email:".concat(q.id);
    var field = q.id;

    if (!isEmail(answerOther.value)) {
      return appendError(q, id, field, 'local-error', validation.errorMessage);
    }
  }

  return q;
};

var validators$1 = [checkValueTextLength$1, checkValueDateFormat$1, checkValueNumber$1, checkValueEmail$1];

var validate$7 = function validate$7(question) {
  return validators$1.reduce(function (state, validator) {
    return validator(state);
  }, question);
};

var typeId$5 = 'check_box';

var fromExternalQuestion$6 = function fromExternalQuestion$6(source, capability) {
  return mapFromExternalQuestion$6(source, capability);
};

var toExternalQuestion$6 = function toExternalQuestion$6(eq, q, capability) {
  return mapInternalDynamicToExternal(eq, q);
};

var shortUpdate$6 = function shortUpdate$6(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'partial-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  // example of short update usage logic:
  // if there's an error in the error list, run local validations on the question
  if (capability === 'any' && updateType === 'partial-value-change' && 'errors' in q && q.errors.length > 0) {
    return validate$7(q);
  }

  return q;
}; // TODO: evaluate if long updates need to be async


var longUpdate$6 = function longUpdate$6(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (capability === 'any' && updateType === 'full-value-change') {
    return validate$7(q);
  }

  return q;
};

var isCompatible$6 = function isCompatible$6(q) {
  return isExternalQuestionWithTypeId(q) && q.typeId === typeId$5;
};

var isOfQuestionType$6 = isQuestionTypeCheckBox;
var assertQuestionType$6 = assertQuestionTypeCheckBox;
var checkBoxQuestionDefinition = {
  typeId: typeId$5,
  shortUpdate: shortUpdate$6,
  longUpdate: longUpdate$6,
  validate: validate$7,
  fromExternalQuestion: fromExternalQuestion$6,
  toExternalQuestion: toExternalQuestion$6,
  isCompatible: isCompatible$6,
  isOfQuestionType: isOfQuestionType$6,
  assertQuestionType: assertQuestionType$6
};
var baseGuards$4 = baseQuestionGuards('dropdown', 'MULTIPLE_CHOICE', 'SINGLE_ANSWER_MENU');
var isQuestionTypeDropdown = typeGuard(baseGuards$4);

function assertQuestionTypeDropdown(externalQuestion) {
  return typeAssertion(baseGuards$4)(externalQuestion);
}

var mapFromExternalQuestion$5 = function mapFromExternalQuestion$5(externalQuestion, capability) {
  var questionType = mapDynamic({
    typeId: 'dropdown',
    externalQuestion: externalQuestion,
    capability: capability
  });
  assertQuestionTypeDropdown(questionType);
  return questionType;
};

var localError = 'local-error'; // TODO: see if we can move part of these functions's code to the generic
// question utils, leaving just what's specific to SingleTextbox.
// Try to do it in a way that preserves the versatility
// and the simplicity of their implementation

var checkValueTextLength = function checkValueTextLength(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answerOther = q.answerOther;

  if (validation && validation.type === 'TEXT_LENGTH' && answerOther && answerOther.touched) {
    // TODO: check if these fields are enough to help render the error messages properly
    var field = q.id;
    var id = "text-length:".concat(q.id);
    var minLength = validation.minLength,
        maxLength = validation.maxLength,
        errorMessage = validation.errorMessage;

    if (answerOther.value.length > maxLength || answerOther.value.length < minLength) {
      return appendError(q, id, field, localError, errorMessage);
    }
  }

  return q;
};

var strToDate = function strToDate(format) {
  return function (s) {
    return DATE_PATTERNS[format].test(s) ? DATE_BUILDERS[format](s.split('/').map(Number)) : null;
  };
};

var checkValueDateFormat = function checkValueDateFormat(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answerOther = q.answerOther;

  if (validation && (validation.type === 'DATE_INTL' || validation.type === 'DATE_US') && answerOther && answerOther.touched) {
    // TODO: check if these fields are enough to help render the error messages properly
    var field = q.id;
    var id = "date-format:".concat(q.id);
    var minDate = validation.minDate,
        maxDate = validation.maxDate,
        errorMessage = validation.errorMessage;
    var value = answerOther.value;

    var _map7 = [minDate, maxDate, value].map(strToDate(validation.type)),
        _map8 = _slicedToArray2(_map7, 3),
        dmin = _map8[0],
        dmax = _map8[1],
        date = _map8[2];

    if (!date || dmax && date.getTime() > dmax.getTime() || dmin && date.getTime() < dmin.getTime()) {
      return appendError(q, id, field, localError, errorMessage);
    }
  }

  return q;
};

var checkValueNumber = function checkValueNumber(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answerOther = q.answerOther;
  var id = "integer:".concat(q.id);
  var field = q.id;

  if (validation && (validation.type === 'INTEGER' || validation.type === 'DECIMAL') && answerOther && answerOther.touched) {
    var numInt = parseInt(answerOther.value, 10);

    if (Number.isNaN(numInt) && Math.floor(numInt) === numInt && numInt >= validation.minValue && numInt <= validation.maxValue) {
      return q;
    }

    return appendError(q, id, field, localError, validation.errorMessage);
  }

  return q;
};

var checkValueEmail = function checkValueEmail(q) {
  if (!('validation' in q)) {
    return q; // capability does not support validation
  }

  var validation = q.validation,
      answerOther = q.answerOther;

  if (validation && validation.type === 'EMAIL' && answerOther && answerOther.touched) {
    var id = "email:".concat(q.id);
    var field = q.id;

    if (!isEmail(answerOther.value)) {
      return appendError(q, id, field, localError, validation.errorMessage);
    }
  }

  return q;
};

var validators = [checkValueTextLength, checkValueDateFormat, checkValueNumber, checkValueEmail];

var validate$6 = function validate$6(question) {
  return validators.reduce(function (state, validator) {
    return validator(state);
  }, question);
};

var typeId$4 = 'dropdown';

var fromExternalQuestion$5 = function fromExternalQuestion$5(source, capability) {
  return mapFromExternalQuestion$5(source, capability);
};

var toExternalQuestion$5 = function toExternalQuestion$5(eq, q, capability) {
  return mapInternalDynamicToExternal(eq, q);
};

var shortUpdate$5 = function shortUpdate$5(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'partial-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  // example of short update usage logic:
  // if there's an error in the error list, run local validations on the question
  if (capability === 'any' && updateType === 'partial-value-change' && 'errors' in q && q.errors.length > 0) {
    return validate$6(q);
  }

  return q;
}; // TODO: evaluate if long updates need to be async


var longUpdate$5 = function longUpdate$5(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (capability === 'any' && updateType === 'full-value-change') {
    return validate$6(q);
  }

  return q;
};

var isCompatible$5 = function isCompatible$5(q) {
  return isExternalQuestionWithTypeId(q) && q.typeId === typeId$4;
};

var isOfQuestionType$5 = isQuestionTypeDropdown;
var assertQuestionType$5 = assertQuestionTypeDropdown;
var dropdownQuestionDefinition = {
  typeId: typeId$4,
  shortUpdate: shortUpdate$5,
  longUpdate: longUpdate$5,
  validate: validate$6,
  fromExternalQuestion: fromExternalQuestion$5,
  toExternalQuestion: toExternalQuestion$5,
  isCompatible: isCompatible$5,
  isOfQuestionType: isOfQuestionType$5,
  assertQuestionType: assertQuestionType$5
};
var baseGuards$3 = baseQuestionGuards('image_choice_single_answer', 'MULTIPLE_CHOICE', 'SINGLE_ANSWER_IMAGE');
var isQuestionTypeImageChoice = typeGuard(_objectSpread(_objectSpread({}, baseGuards$3), {}, {
  /* To reduce code duplication, we assume the discrepancies between
   * "single answer" and "many answers" question types are limited to "typeId" and "variant".
   */
  typeId: isEither([isFixed('image_choice_single_answer'), isFixed('image_choice_many_answers')]),
  variant: isEither([isFixed('SINGLE_ANSWER_IMAGE'), isFixed('MANY_ANSWERS_IMAGE')])
}));

function assertQuestionTypeImageChoice(q) {
  return typeAssertion(_objectSpread(_objectSpread({}, baseGuards$3), {}, {
    /* To reduce code duplication, we assume the discrepancies between
     * "single answer" and "many answers" question types are limited to "typeId" and "variant".
     */
    typeId: isEither([isFixed('image_choice_single_answer'), isFixed('image_choice_many_answers')]),
    variant: isEither([isFixed('SINGLE_ANSWER_IMAGE'), isFixed('MANY_ANSWERS_IMAGE')])
  }))(q);
}

var validate$5 = function validate$5(question) {
  return question;
};

var mapFromExternalQuestion$4 = function mapFromExternalQuestion$4(externalQuestion, capability) {
  var questionType = mapDynamic({
    typeId: 'image_choice',
    externalQuestion: externalQuestion,
    capability: capability
  });
  assertQuestionTypeImageChoice(questionType);
  return questionType;
}; // standard interface for QuestionType to convert to and from
// the External Generic QuestionType


var typeIdSingle = 'image_choice_single_answer';
var typeIdMany = 'image_choice_many_answers';

var fromExternalQuestion$4 = function fromExternalQuestion$4(source, capability) {
  return mapFromExternalQuestion$4(source, capability);
};

var toExternalQuestion$4 = function toExternalQuestion$4(eq, q, capability) {
  return mapInternalDynamicToExternal(eq, q);
};

var shortUpdate$4 = function shortUpdate$4(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'partial-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  // example of short update usage logic:
  // if there's an error in the error list, run local validations on the question
  if (capability === 'any' && updateType === 'partial-value-change' && 'errors' in q && q.errors.length > 0) {
    return validate$5(q);
  }

  return q;
}; // TODO: evaluate if long updates need to be async


var longUpdate$4 = function longUpdate$4(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (capability === 'any' && updateType === 'full-value-change') {
    return validate$5(q);
  }

  return q;
};

var isCompatible$4 = function isCompatible$4(q) {
  return isExternalQuestionWithTypeId(q) && (q.typeId === typeIdSingle || q.typeId === typeIdMany);
};

var isOfQuestionType$4 = isQuestionTypeImageChoice;
var assertQuestionType$4 = assertQuestionTypeImageChoice;
var imageChoiceSingleAnswerQuestionDefinition = {
  typeId: typeIdSingle,
  shortUpdate: shortUpdate$4,
  longUpdate: longUpdate$4,
  validate: validate$5,
  fromExternalQuestion: fromExternalQuestion$4,
  toExternalQuestion: toExternalQuestion$4,
  isCompatible: isCompatible$4,
  isOfQuestionType: isOfQuestionType$4,
  assertQuestionType: assertQuestionType$4
};
var imageChoiceManyAnswersQuestionDefinition = {
  typeId: typeIdMany,
  shortUpdate: shortUpdate$4,
  longUpdate: longUpdate$4,
  validate: validate$5,
  fromExternalQuestion: fromExternalQuestion$4,
  toExternalQuestion: toExternalQuestion$4,
  isCompatible: isCompatible$4,
  isOfQuestionType: isOfQuestionType$4,
  assertQuestionType: assertQuestionType$4
};

var validate$4 = function validate$4(question) {
  return question;
};

var baseGuards$2 = baseQuestionGuards('slider', 'SLIDER', 'SINGLE_SLIDER');
var isQuestionTypeSlider = typeGuard(baseGuards$2); // export const assertQuestionTypeSlider =

function assertQuestionTypeSlider(externalQuestion) {
  return typeAssertion(baseGuards$2)(externalQuestion);
}

var mapFromExternalQuestion$3 = function mapFromExternalQuestion$3(externalQuestion, capability) {
  var questionType = mapDynamic({
    typeId: 'slider',
    externalQuestion: externalQuestion,
    capability: capability
  });
  assertQuestionTypeSlider(questionType);
  return questionType;
};

var typeId$3 = 'slider';

var shortUpdate$3 = function shortUpdate$3(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'partial-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (capability === 'any' && updateType === 'partial-value-change' && 'errors' in q && q.errors.length > 0) {
    return validate$4(q);
  }

  return q;
};

var longUpdate$3 = function longUpdate$3(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (capability === 'any' && updateType === 'full-value-change') {
    return validate$4(q);
  }

  return q;
};

var isCompatible$3 = function isCompatible$3(q) {
  return isExternalQuestionWithTypeId(q) && q.typeId === typeId$3;
};

var isOfQuestionType$3 = isQuestionTypeSlider;
var assertQuestionType$3 = assertQuestionTypeSlider;

var fromExternalQuestion$3 = function fromExternalQuestion$3(source, capability) {
  return mapFromExternalQuestion$3(source, capability);
};

var toExternalQuestion$3 = function toExternalQuestion$3(eq, q, capability) {
  return mapInternalDynamicToExternal(eq, q);
};

var sliderQuestionDefinition = {
  typeId: typeId$3,
  shortUpdate: shortUpdate$3,
  longUpdate: longUpdate$3,
  validate: validate$4,
  fromExternalQuestion: fromExternalQuestion$3,
  toExternalQuestion: toExternalQuestion$3,
  isCompatible: isCompatible$3,
  isOfQuestionType: isOfQuestionType$3,
  assertQuestionType: assertQuestionType$3
};

var validate$3 = function validate$3(question) {
  return question;
};

var baseGuards$1 = baseQuestionGuards('star_rating', 'RATING_SCALE', 'SINGLE_ANSWER_SYMBOL');
var isQuestionTypeStarRating = typeGuard(baseGuards$1);

function assertQuestionTypeStarRating(externalQuestion) {
  return typeAssertion(baseGuards$1)(externalQuestion);
}

var mapFromExternalQuestion$2 = function mapFromExternalQuestion$2(externalQuestion, capability) {
  var questionType = mapDynamic({
    typeId: 'star_rating',
    externalQuestion: externalQuestion,
    capability: capability
  });
  assertQuestionTypeStarRating(questionType);
  return questionType;
};

var typeId$2 = 'star_rating';

var shortUpdate$2 = function shortUpdate$2(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'partial-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (capability === 'any' && updateType === 'partial-value-change' && 'errors' in q && q.errors.length > 0) {
    return validate$3(q);
  }

  return q;
};

var longUpdate$2 = function longUpdate$2(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full-value-change';
  var capability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (capability === 'any' && updateType === 'full-value-change') {
    return validate$3(q);
  }

  return q;
};

var isCompatible$2 = function isCompatible$2(q) {
  return isExternalQuestionWithTypeId(q) && q.typeId === typeId$2;
};

var isOfQuestionType$2 = isQuestionTypeStarRating;
var assertQuestionType$2 = assertQuestionTypeStarRating;

var fromExternalQuestion$2 = function fromExternalQuestion$2(source, capability) {
  return mapFromExternalQuestion$2(source, capability);
};

var toExternalQuestion$2 = function toExternalQuestion$2(eq, q, capability) {
  return mapInternalDynamicToExternal(eq, q);
};

var starRatingQuestionDefinition = {
  typeId: typeId$2,
  shortUpdate: shortUpdate$2,
  longUpdate: longUpdate$2,
  validate: validate$3,
  fromExternalQuestion: fromExternalQuestion$2,
  toExternalQuestion: toExternalQuestion$2,
  isCompatible: isCompatible$2,
  isOfQuestionType: isOfQuestionType$2,
  assertQuestionType: assertQuestionType$2
};
var baseSingleAnswerGuards = baseQuestionGuards('matrix', 'MATRIX', 'SINGLE_ANSWER_RADIO');
var baseManyAnswersGuards = baseQuestionGuards('matrix', 'MATRIX', 'MANY_ANSWERS_CHECKBOX');
var isQuestionTypeMatrixSingleAnswer = typeGuard(baseSingleAnswerGuards);
var isQuestionTypeMatrixManyAnswers = typeGuard(baseManyAnswersGuards);
var isQuestionTypeMatrix = isEither([isQuestionTypeMatrixSingleAnswer, isQuestionTypeMatrixManyAnswers]);

function assertQuestionTypeMatrix(externalQuestion) {
  // TODO: Refactor for better error messages
  if (!isQuestionTypeMatrix(externalQuestion)) {
    throw new Error('Question data does not match any supported question type.');
  }
}

var mapFromExternalQuestion$1 = function mapFromExternalQuestion$1(externalQuestion, capability) {
  var questionType = mapDynamic({
    typeId: 'matrix',
    externalQuestion: externalQuestion,
    capability: capability
  });
  assertQuestionTypeMatrix(questionType);
  return questionType;
};

var validate$2 = function validate$2(question) {
  return question;
};

var typeId$1 = 'matrix';

var shortUpdate$1 = function shortUpdate$1(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'partial-value-change';
  var feature = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (feature === 'any' && updateType === 'partial-value-change' && 'errors' in q && q.errors.length > 0) {
    return validate$2(q);
  }

  return q;
};

var longUpdate$1 = function longUpdate$1(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full-value-change';
  var feature = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (feature === 'any' && updateType === 'full-value-change') {
    return validate$2(q);
  }

  return q;
};

var isCompatible$1 = function isCompatible$1(q) {
  return isExternalQuestionWithTypeId(q) && q.typeId === typeId$1;
};

var isOfQuestionType$1 = isQuestionTypeMatrix;
var assertQuestionType$1 = assertQuestionTypeMatrix;

var fromExternalQuestion$1 = function fromExternalQuestion$1(source, capability) {
  return mapFromExternalQuestion$1(source, capability);
};

var toExternalQuestion$1 = function toExternalQuestion$1(eq, q, capability) {
  return mapInternalDynamicToExternal(eq, q);
};

var validate$1 = function validate$1(question) {
  return question;
};

var matrixQuestionDefinition = {
  typeId: typeId$1,
  shortUpdate: shortUpdate$1,
  longUpdate: longUpdate$1,
  fromExternalQuestion: fromExternalQuestion$1,
  toExternalQuestion: toExternalQuestion$1,
  isOfQuestionType: isOfQuestionType$1,
  isCompatible: isCompatible$1,
  assertQuestionType: assertQuestionType$1,
  validate: validate$1
};

var validate = function validate(question) {
  return question;
};

var baseGuards = baseQuestionGuards('ranking', 'RANKING', 'SINGLE_ANSWER_RADIO'); // TODO: Remove Partial here

var isQuestionTypeRanking = typeGuard(baseGuards); // TODO: Remove Partial here

function assertQuestionTypeRanking(externalQuestion) {
  return typeAssertion(baseGuards)(externalQuestion);
}

var mapFromExternalQuestion = function mapFromExternalQuestion(externalQuestion, capability) {
  var questionType = mapDynamic({
    typeId: 'ranking',
    externalQuestion: externalQuestion,
    capability: capability
  });
  assertQuestionTypeRanking(questionType);
  return questionType;
};

var typeId = 'ranking';

var shortUpdate = function shortUpdate(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'partial-value-change';
  var feature = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (feature === 'any' && updateType === 'partial-value-change' && 'errors' in q && q.errors.length > 0) {
    return validate(q);
  }

  return q;
};

var longUpdate = function longUpdate(q) {
  var updateType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full-value-change';
  var feature = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'any';

  if (feature === 'any' && updateType === 'full-value-change') {
    return validate(q);
  }

  return q;
};

var isCompatible = function isCompatible(q) {
  return isExternalQuestionWithTypeId(q) && q.typeId === typeId;
};

var isOfQuestionType = isQuestionTypeRanking;
var assertQuestionType = assertQuestionTypeRanking;

var fromExternalQuestion = function fromExternalQuestion(source, capability) {
  return mapFromExternalQuestion(source, capability);
};

var toExternalQuestion = function toExternalQuestion(eq, q, capability) {
  return mapInternalDynamicToExternal(eq, q);
};

var rankingQuestionDefinition = {
  typeId: typeId,
  shortUpdate: shortUpdate,
  longUpdate: longUpdate,
  validate: validate,
  fromExternalQuestion: fromExternalQuestion,
  toExternalQuestion: toExternalQuestion,
  isCompatible: isCompatible,
  isOfQuestionType: isOfQuestionType,
  assertQuestionType: assertQuestionType
};
var questionTypeDefinitionModules = [singleTextboxQuestionDefinition, multipleTextboxQuestionDefinition, commentBoxQuestionDefinition, multipleChoiceQuestionDefinition, checkBoxQuestionDefinition, imageChoiceSingleAnswerQuestionDefinition, dropdownQuestionDefinition, sliderQuestionDefinition, starRatingQuestionDefinition, matrixQuestionDefinition, rankingQuestionDefinition];

var findByType = function findByType(typeId) {
  return function (qd) {
    return qd.typeId === typeId;
  };
};

var pickQuestionTypeDefinition = function pickQuestionTypeDefinition(typeId) {
  var res = questionTypeDefinitionModules.find(findByType(typeId));

  if (res === undefined) {
    throw new Error("Unable to find module definition for type ".concat(typeId));
  }

  return res;
};

var selectQuestionTypeDefinition = function selectQuestionTypeDefinition(q) {
  var _a;

  return (_a = questionTypeDefinitionModules.find(function (_ref11) {
    var isCompatible = _ref11.isCompatible;
    return isCompatible(q);
  })) !== null && _a !== void 0 ? _a : null;
}; /// Aggregate Response Guard Helpers
/// GQL Types that will be generated soon.


var isAggregateResponseHeaderItem = typeGuard({
  id: isString,
  label: isString,
  weight: isNullable(isNumber)
});
var isAggregateResponseHeader = typeGuard({
  id: isString,
  items: isArrayOf(isAggregateResponseHeaderItem)
});
var isAggregateResponseCell = typeGuard({
  rowItem: isNullable(isAggregateResponseHeaderItem),
  columnItem: isNullable(isAggregateResponseHeaderItem),
  groupItem: isNullable(isAggregateResponseHeaderItem),
  percentage: isNumber,
  total: isNumber
});
var aggregateResponseBasicStatDimension = ['ROWS', 'COLUMNS', 'GROUPS'];
var isAggregateResponseBasicStats = typeGuard({
  across: isNullable(isOneOf(aggregateResponseBasicStatDimension)),
  row: isNullable(isAggregateResponseHeaderItem),
  column: isNullable(isAggregateResponseHeaderItem),
  group: isNullable(isAggregateResponseHeaderItem)
}); // One dimensional aggregate response

var isOneDimensionalAggregateResponseCell = typeGuard({
  rowItem: isAggregateResponseHeaderItem,
  columnItem: isNull,
  groupItem: isNull,
  percentage: isNumber,
  total: isNumber
});
var isOneDimensionalAggregateResponse = typeGuard({
  id: isString,
  type: isFixed('ONE_D'),
  rowHeader: isAggregateResponseHeader,
  columnHeader: isNull,
  groupHeader: isNull,
  data: isArrayOf(isOneDimensionalAggregateResponseCell),
  stats: isArrayOf(isAggregateResponseBasicStats)
}); // Two dimensional aggregate response

var isTwoDimensionalAggregateResponseCell = typeGuard({
  rowItem: isAggregateResponseHeaderItem,
  columnItem: isAggregateResponseHeaderItem,
  groupItem: isNull,
  percentage: isNumber,
  total: isNumber
});
var isTwoDimensionalAggregateResponse = typeGuard({
  id: isString,
  type: isFixed('TWO_D'),
  rowHeader: isAggregateResponseHeader,
  columnHeader: isAggregateResponseHeader,
  groupHeader: isNull,
  data: isArrayOf(isTwoDimensionalAggregateResponseCell),
  stats: isArrayOf(isAggregateResponseBasicStats)
}); // Three dimensional aggregate response

var isThreeDimensionalAggregateResponseCell = typeGuard({
  rowItem: isAggregateResponseHeaderItem,
  columnItem: isAggregateResponseHeaderItem,
  groupItem: isAggregateResponseHeaderItem,
  percentage: isNumber,
  total: isNumber
});
var isThreeDimensionalAggregateResponse = typeGuard({
  id: isString,
  type: isFixed('THREE_D'),
  rowHeader: isAggregateResponseHeader,
  columnHeader: isAggregateResponseHeader,
  groupHeader: isAggregateResponseHeader,
  data: isArrayOf(isThreeDimensionalAggregateResponseCell),
  stats: isArrayOf(isAggregateResponseBasicStats)
}); // Transformed type guards

var isOneDimensionalChartData = typeGuard({
  id: isString,
  rowID: isString,
  rowLabel: isString,
  total: isNumber,
  percentage: isNumber
});
var isTwoDimensionalData = typeGuard({
  columnID: isString,
  columnLabel: isString,
  data: isArrayOf(isOneDimensionalChartData)
});
var isThreeDimensionalData = typeGuard({
  groupID: isString,
  groupLabel: isString,
  data: isArrayOf(isTwoDimensionalData)
});
export { SENTIMENTS, aggregateResponseBasicStatDimension, assertExternalQuestionWithIds, assertQuestionTypeCheckBox, assertQuestionTypeCommentBox, assertQuestionTypeDropdown, assertQuestionTypeImageChoice, assertQuestionTypeMatrix, assertQuestionTypeMultipleChoice, assertQuestionTypeMultipleTextbox, assertQuestionTypeRanking, assertQuestionTypeSingleTextbox, assertQuestionTypeSlider, assertQuestionTypeStarRating, baseQuestionGuards, checkBoxQuestionDefinition, commentBoxQuestionDefinition, dropdownQuestionDefinition, findByType, fixedWidthOptions, getTypeId, imageChoiceManyAnswersQuestionDefinition, imageChoiceSingleAnswerQuestionDefinition, isAggregateResponseBasicStats, isAggregateResponseCell, isAggregateResponseHeader, isAggregateResponseHeaderItem, isExternalQuestionWithTypeId, isMultipleChoiceAnswerType, isOneDimensionalAggregateResponse, isOneDimensionalChartData, isOtherAnswerChoiceType, isOtherAnswerCommentType, isQuestionError, isQuestionType, isQuestionTypeCheckBox, isQuestionTypeCommentBox, isQuestionTypeDropdown, isQuestionTypeImageChoice, isQuestionTypeMatrix, isQuestionTypeMultipleChoice, isQuestionTypeMultipleTextbox, isQuestionTypeRanking, isQuestionTypeSingleTextbox, isQuestionTypeSlider, isQuestionTypeStarRating, isQuestionValidationMultipleChoice, isThreeDimensionalAggregateResponse, isThreeDimensionalData, isTwoDimensionalAggregateResponse, isTwoDimensionalData, matrixQuestionDefinition, multipleChoiceQuestionDefinition, multipleTextboxQuestionDefinition, pickQuestionTypeDefinition, questionTypeDefinitionModules, questionTypeFamilies, questionTypeFileFormats, questionTypeHeaderColumnWidths, questionTypeIds, questionTypeLayoutPlacements, questionTypeMultipleChoiceLayouts, questionTypeRequiredPredicateTypes, questionTypeSkipLogicDestinationTypes, questionTypeSkipLogicTypes, questionTypeSortingKinds, questionTypeTextLineOptions, questionTypeTextWidthOptions, questionTypeValidationTypes, questionTypeVariants, rankingQuestionDefinition, ratingScaleSymbols, relativeWidthOptions, selectQuestionTypeDefinition, singleTextboxQuestionDefinition, sliderQuestionDefinition, starRatingQuestionDefinition };